(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $59c4f5e8925f3128$exports = {};
(function() {
    "use strict";
    var doc = document;
    var win = window;
    var docEle = doc.documentElement;
    var createElement = doc.createElement.bind(doc);
    var div = createElement('div');
    var table = createElement('table');
    var tbody = createElement('tbody');
    var tr = createElement('tr');
    var isArray = Array.isArray, ArrayPrototype = Array.prototype;
    var concat = ArrayPrototype.concat, filter = ArrayPrototype.filter, indexOf = ArrayPrototype.indexOf, map = ArrayPrototype.map, push = ArrayPrototype.push, slice = ArrayPrototype.slice, some = ArrayPrototype.some, splice = ArrayPrototype.splice;
    var idRe = /^#(?:[\w-]|\\.|[^\x00-\xa0])*$/;
    var classRe = /^\.(?:[\w-]|\\.|[^\x00-\xa0])*$/;
    var htmlRe = /<.+>/;
    var tagRe = /^\w+$/;
    // @require ./variables.ts
    function find(selector, context) {
        var isFragment = isDocumentFragment(context);
        return !selector || !isFragment && !isDocument(context) && !isElement(context) ? [] : !isFragment && classRe.test(selector) ? context.getElementsByClassName(selector.slice(1).replace(/\\/g, '')) : !isFragment && tagRe.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    }
    // @require ./find.ts
    // @require ./variables.ts
    var Cash = /** @class */ function() {
        function Cash(selector, context) {
            if (!selector) return;
            if (isCash(selector)) return selector;
            var eles = selector;
            if (isString(selector)) {
                var ctx = context || doc;
                eles = idRe.test(selector) && isDocument(ctx) ? ctx.getElementById(selector.slice(1).replace(/\\/g, '')) : htmlRe.test(selector) ? parseHTML(selector) : isCash(ctx) ? ctx.find(selector) : isString(ctx) ? cash(ctx).find(selector) : find(selector, ctx);
                if (!eles) return;
            } else if (isFunction(selector)) return this.ready(selector); //FIXME: `fn.ready` is not included in `core`, but it's actually a core functionality
            if (eles.nodeType || eles === win) eles = [
                eles
            ];
            this.length = eles.length;
            for(var i = 0, l = this.length; i < l; i++)this[i] = eles[i];
        }
        Cash.prototype.init = function(selector, context) {
            return new Cash(selector, context);
        };
        return Cash;
    }();
    var fn = Cash.prototype;
    var cash = fn.init;
    cash.fn = cash.prototype = fn; // Ensuring that `cash () instanceof cash`
    fn.length = 0;
    fn.splice = splice; // Ensuring a cash collection gets printed as array-like in Chrome's devtools
    if (typeof Symbol === 'function') fn[Symbol['iterator']] = ArrayPrototype[Symbol['iterator']];
    function isCash(value) {
        return value instanceof Cash;
    }
    function isWindow(value) {
        return !!value && value === value.window;
    }
    function isDocument(value) {
        return !!value && value.nodeType === 9;
    }
    function isDocumentFragment(value) {
        return !!value && value.nodeType === 11;
    }
    function isElement(value) {
        return !!value && value.nodeType === 1;
    }
    function isText(value) {
        return !!value && value.nodeType === 3;
    }
    function isBoolean(value) {
        return typeof value === 'boolean';
    }
    function isFunction(value) {
        return typeof value === 'function';
    }
    function isString(value) {
        return typeof value === 'string';
    }
    function isUndefined(value) {
        return value === undefined;
    }
    function isNull(value) {
        return value === null;
    }
    function isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
    function isPlainObject(value) {
        if (typeof value !== 'object' || value === null) return false;
        var proto = Object.getPrototypeOf(value);
        return proto === null || proto === Object.prototype;
    }
    cash.isWindow = isWindow;
    cash.isFunction = isFunction;
    cash.isArray = isArray;
    cash.isNumeric = isNumeric;
    cash.isPlainObject = isPlainObject;
    function each(arr, callback, _reverse) {
        if (_reverse) {
            var i = arr.length;
            while(i--){
                if (callback.call(arr[i], i, arr[i]) === false) return arr;
            }
        } else if (isPlainObject(arr)) {
            var keys = Object.keys(arr);
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i];
                if (callback.call(arr[key], key, arr[key]) === false) return arr;
            }
        } else for(var i = 0, l = arr.length; i < l; i++){
            if (callback.call(arr[i], i, arr[i]) === false) return arr;
        }
        return arr;
    }
    cash.each = each;
    fn.each = function(callback) {
        return each(this, callback);
    };
    fn.empty = function() {
        return this.each(function(i, ele) {
            while(ele.firstChild)ele.removeChild(ele.firstChild);
        });
    };
    function extend() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        var deep = isBoolean(sources[0]) ? sources.shift() : false;
        var target = sources.shift();
        var length = sources.length;
        if (!target) return {};
        if (!length) return extend(deep, cash, target);
        for(var i = 0; i < length; i++){
            var source = sources[i];
            for(var key in source)if (deep && (isArray(source[key]) || isPlainObject(source[key]))) {
                if (!target[key] || target[key].constructor !== source[key].constructor) target[key] = new source[key].constructor();
                extend(deep, target[key], source[key]);
            } else target[key] = source[key];
        }
        return target;
    }
    cash.extend = extend;
    fn.extend = function(plugins) {
        return extend(fn, plugins);
    };
    // @require ./type_checking.ts
    var splitValuesRe = /\S+/g;
    function getSplitValues(str) {
        return isString(str) ? str.match(splitValuesRe) || [] : [];
    }
    fn.toggleClass = function(cls, force) {
        var classes = getSplitValues(cls);
        var isForce = !isUndefined(force);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            each(classes, function(i, c) {
                if (isForce) force ? ele.classList.add(c) : ele.classList.remove(c);
                else ele.classList.toggle(c);
            });
        });
    };
    fn.addClass = function(cls) {
        return this.toggleClass(cls, true);
    };
    fn.removeAttr = function(attr) {
        var attrs = getSplitValues(attr);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            each(attrs, function(i, a) {
                ele.removeAttribute(a);
            });
        });
    };
    function attr(attr, value) {
        if (!attr) return;
        if (isString(attr)) {
            if (arguments.length < 2) {
                if (!this[0] || !isElement(this[0])) return;
                var value_1 = this[0].getAttribute(attr);
                return isNull(value_1) ? undefined : value_1;
            }
            if (isUndefined(value)) return this;
            if (isNull(value)) return this.removeAttr(attr);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                ele.setAttribute(attr, value);
            });
        }
        for(var key in attr)this.attr(key, attr[key]);
        return this;
    }
    fn.attr = attr;
    fn.removeClass = function(cls) {
        if (arguments.length) return this.toggleClass(cls, false);
        return this.attr('class', '');
    };
    fn.hasClass = function(cls) {
        return !!cls && some.call(this, function(ele) {
            return isElement(ele) && ele.classList.contains(cls);
        });
    };
    fn.get = function(index) {
        if (isUndefined(index)) return slice.call(this);
        index = Number(index);
        return this[index < 0 ? index + this.length : index];
    };
    fn.eq = function(index) {
        return cash(this.get(index));
    };
    fn.first = function() {
        return this.eq(0);
    };
    fn.last = function() {
        return this.eq(-1);
    };
    function text(text) {
        if (isUndefined(text)) return this.get().map(function(ele) {
            return isElement(ele) || isText(ele) ? ele.textContent : '';
        }).join('');
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            ele.textContent = text;
        });
    }
    fn.text = text;
    // @require core/type_checking.ts
    // @require core/variables.ts
    function computeStyle(ele, prop, isVariable) {
        if (!isElement(ele)) return;
        var style = win.getComputedStyle(ele, null);
        return isVariable ? style.getPropertyValue(prop) || undefined : style[prop] || ele.style[prop];
    }
    // @require ./compute_style.ts
    function computeStyleInt(ele, prop) {
        return parseInt(computeStyle(ele, prop), 10) || 0;
    }
    // @require css/helpers/compute_style_int.ts
    function getExtraSpace(ele, xAxis) {
        return computeStyleInt(ele, "border".concat(xAxis ? 'Left' : 'Top', "Width")) + computeStyleInt(ele, "padding".concat(xAxis ? 'Left' : 'Top')) + computeStyleInt(ele, "padding".concat(xAxis ? 'Right' : 'Bottom')) + computeStyleInt(ele, "border".concat(xAxis ? 'Right' : 'Bottom', "Width"));
    }
    // @require css/helpers/compute_style.ts
    var defaultDisplay = {};
    function getDefaultDisplay(tagName) {
        if (defaultDisplay[tagName]) return defaultDisplay[tagName];
        var ele = createElement(tagName);
        doc.body.insertBefore(ele, null);
        var display = computeStyle(ele, 'display');
        doc.body.removeChild(ele);
        return defaultDisplay[tagName] = display !== 'none' ? display : 'block';
    }
    // @require css/helpers/compute_style.ts
    function isHidden(ele) {
        return computeStyle(ele, 'display') === 'none';
    }
    // @require ./cash.ts
    function matches(ele, selector) {
        var matches = ele && (ele['matches'] || ele['webkitMatchesSelector'] || ele['msMatchesSelector']);
        return !!matches && !!selector && matches.call(ele, selector);
    }
    // @require ./matches.ts
    // @require ./type_checking.ts
    function getCompareFunction(comparator) {
        return isString(comparator) ? function(i, ele) {
            return matches(ele, comparator);
        } : isFunction(comparator) ? comparator : isCash(comparator) ? function(i, ele) {
            return comparator.is(ele);
        } : !comparator ? function() {
            return false;
        } : function(i, ele) {
            return ele === comparator;
        };
    }
    fn.filter = function(comparator) {
        var compare = getCompareFunction(comparator);
        return cash(filter.call(this, function(ele, i) {
            return compare.call(ele, i, ele);
        }));
    };
    // @require collection/filter.ts
    function filtered(collection, comparator) {
        return !comparator ? collection : collection.filter(comparator);
    }
    fn.detach = function(comparator) {
        filtered(this, comparator).each(function(i, ele) {
            if (ele.parentNode) ele.parentNode.removeChild(ele);
        });
        return this;
    };
    var fragmentRe = /^\s*<(\w+)[^>]*>/;
    var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
    var containers = {
        '*': div,
        tr: tbody,
        td: tr,
        th: tr,
        thead: table,
        tbody: table,
        tfoot: table
    };
    //TODO: Create elements inside a document fragment, in order to prevent inline event handlers from firing
    //TODO: Ensure the created elements have the fragment as their parent instead of null, this also ensures we can deal with detatched nodes more reliably
    function parseHTML(html) {
        if (!isString(html)) return [];
        if (singleTagRe.test(html)) return [
            createElement(RegExp.$1)
        ];
        var fragment = fragmentRe.test(html) && RegExp.$1;
        var container = containers[fragment] || containers['*'];
        container.innerHTML = html;
        return cash(container.childNodes).detach().get();
    }
    cash.parseHTML = parseHTML;
    fn.has = function(selector) {
        var comparator = isString(selector) ? function(i, ele) {
            return find(selector, ele).length;
        } : function(i, ele) {
            return ele.contains(selector);
        };
        return this.filter(comparator);
    };
    fn.not = function(comparator) {
        var compare = getCompareFunction(comparator);
        return this.filter(function(i, ele) {
            return (!isString(comparator) || isElement(ele)) && !compare.call(ele, i, ele);
        });
    };
    function pluck(arr, prop, deep, until) {
        var plucked = [];
        var isCallback = isFunction(prop);
        var compare = until && getCompareFunction(until);
        for(var i = 0, l = arr.length; i < l; i++)if (isCallback) {
            var val_1 = prop(arr[i]);
            if (val_1.length) push.apply(plucked, val_1);
        } else {
            var val_2 = arr[i][prop];
            while(val_2 != null){
                if (until && compare(-1, val_2)) break;
                plucked.push(val_2);
                val_2 = deep ? val_2[prop] : null;
            }
        }
        return plucked;
    }
    // @require core/pluck.ts
    // @require core/variables.ts
    function getValue(ele) {
        if (ele.multiple && ele.options) return pluck(filter.call(ele.options, function(option) {
            return option.selected && !option.disabled && !option.parentNode.disabled;
        }), 'value');
        return ele.value || '';
    }
    function val(value) {
        if (!arguments.length) return this[0] && getValue(this[0]);
        return this.each(function(i, ele) {
            var isSelect = ele.multiple && ele.options;
            if (isSelect || checkableRe.test(ele.type)) {
                var eleValue_1 = isArray(value) ? map.call(value, String) : isNull(value) ? [] : [
                    String(value)
                ];
                if (isSelect) each(ele.options, function(i, option) {
                    option.selected = eleValue_1.indexOf(option.value) >= 0;
                }, true);
                else ele.checked = eleValue_1.indexOf(ele.value) >= 0;
            } else ele.value = isUndefined(value) || isNull(value) ? '' : value;
        });
    }
    fn.val = val;
    fn.is = function(comparator) {
        var compare = getCompareFunction(comparator);
        return some.call(this, function(ele, i) {
            return compare.call(ele, i, ele);
        });
    };
    cash.guid = 1;
    function unique(arr) {
        return arr.length > 1 ? filter.call(arr, function(item, index, self) {
            return indexOf.call(self, item) === index;
        }) : arr;
    }
    cash.unique = unique;
    fn.add = function(selector, context) {
        return cash(unique(this.get().concat(cash(selector, context).get())));
    };
    fn.children = function(comparator) {
        return filtered(cash(unique(pluck(this, function(ele) {
            return ele.children;
        }))), comparator);
    };
    fn.parent = function(comparator) {
        return filtered(cash(unique(pluck(this, 'parentNode'))), comparator);
    };
    fn.index = function(selector) {
        var child = selector ? cash(selector)[0] : this[0];
        var collection = selector ? this : cash(child).parent().children();
        return indexOf.call(collection, child);
    };
    fn.closest = function(comparator) {
        var filtered = this.filter(comparator);
        if (filtered.length) return filtered;
        var $parent = this.parent();
        if (!$parent.length) return filtered;
        return $parent.closest(comparator);
    };
    fn.siblings = function(comparator) {
        return filtered(cash(unique(pluck(this, function(ele) {
            return cash(ele).parent().children().not(ele);
        }))), comparator);
    };
    fn.find = function(selector) {
        return cash(unique(pluck(this, function(ele) {
            return find(selector, ele);
        })));
    };
    // @require core/variables.ts
    // @require collection/filter.ts
    // @require traversal/find.ts
    var HTMLCDATARe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    var scriptTypeRe = /^$|^module$|\/(java|ecma)script/i;
    var scriptAttributes = [
        'type',
        'src',
        'nonce',
        'noModule'
    ];
    function evalScripts(node, doc) {
        var collection = cash(node);
        collection.filter('script').add(collection.find('script')).each(function(i, ele) {
            if (scriptTypeRe.test(ele.type) && docEle.contains(ele)) {
                var script_1 = createElement('script');
                script_1.text = ele.textContent.replace(HTMLCDATARe, '');
                each(scriptAttributes, function(i, attr) {
                    if (ele[attr]) script_1[attr] = ele[attr];
                });
                doc.head.insertBefore(script_1, null);
                doc.head.removeChild(script_1);
            }
        });
    }
    // @require ./eval_scripts.ts
    function insertElement(anchor, target, left, inside, evaluate) {
        if (inside) anchor.insertBefore(target, left ? anchor.firstChild : null);
        else if (anchor.nodeName === 'HTML') anchor.parentNode.replaceChild(target, anchor);
        else anchor.parentNode.insertBefore(target, left ? anchor : anchor.nextSibling);
        if (evaluate) evalScripts(target, anchor.ownerDocument);
    }
    // @require ./insert_element.ts
    function insertSelectors(selectors, anchors, inverse, left, inside, reverseLoop1, reverseLoop2, reverseLoop3) {
        each(selectors, function(si, selector) {
            each(cash(selector), function(ti, target) {
                each(cash(anchors), function(ai, anchor) {
                    var anchorFinal = inverse ? target : anchor;
                    var targetFinal = inverse ? anchor : target;
                    var indexFinal = inverse ? ti : ai;
                    insertElement(anchorFinal, !indexFinal ? targetFinal : targetFinal.cloneNode(true), left, inside, !indexFinal);
                }, reverseLoop3);
            }, reverseLoop2);
        }, reverseLoop1);
        return anchors;
    }
    fn.after = function() {
        return insertSelectors(arguments, this, false, false, false, true, true);
    };
    fn.append = function() {
        return insertSelectors(arguments, this, false, false, true);
    };
    function html(html) {
        if (!arguments.length) return this[0] && this[0].innerHTML;
        if (isUndefined(html)) return this;
        var hasScript = /<script[\s>]/.test(html);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            if (hasScript) cash(ele).empty().append(html);
            else ele.innerHTML = html;
        });
    }
    fn.html = html;
    fn.appendTo = function(selector) {
        return insertSelectors(arguments, this, true, false, true);
    };
    fn.wrapInner = function(selector) {
        return this.each(function(i, ele) {
            var $ele = cash(ele);
            var contents = $ele.contents();
            contents.length ? contents.wrapAll(selector) : $ele.append(selector);
        });
    };
    fn.before = function() {
        return insertSelectors(arguments, this, false, true);
    };
    fn.wrapAll = function(selector) {
        var structure = cash(selector);
        var wrapper = structure[0];
        while(wrapper.children.length)wrapper = wrapper.firstElementChild;
        this.first().before(structure);
        return this.appendTo(wrapper);
    };
    fn.wrap = function(selector) {
        return this.each(function(i, ele) {
            var wrapper = cash(selector)[0];
            cash(ele).wrapAll(!i ? wrapper : wrapper.cloneNode(true));
        });
    };
    fn.insertAfter = function(selector) {
        return insertSelectors(arguments, this, true, false, false, false, false, true);
    };
    fn.insertBefore = function(selector) {
        return insertSelectors(arguments, this, true, true);
    };
    fn.prepend = function() {
        return insertSelectors(arguments, this, false, true, true, true, true);
    };
    fn.prependTo = function(selector) {
        return insertSelectors(arguments, this, true, true, true, false, false, true);
    };
    fn.contents = function() {
        return cash(unique(pluck(this, function(ele) {
            return ele.tagName === 'IFRAME' ? [
                ele.contentDocument
            ] : ele.tagName === 'TEMPLATE' ? ele.content.childNodes : ele.childNodes;
        })));
    };
    fn.next = function(comparator, _all, _until) {
        return filtered(cash(unique(pluck(this, 'nextElementSibling', _all, _until))), comparator);
    };
    fn.nextAll = function(comparator) {
        return this.next(comparator, true);
    };
    fn.nextUntil = function(until, comparator) {
        return this.next(comparator, true, until);
    };
    fn.parents = function(comparator, _until) {
        return filtered(cash(unique(pluck(this, 'parentElement', true, _until))), comparator);
    };
    fn.parentsUntil = function(until, comparator) {
        return this.parents(comparator, until);
    };
    fn.prev = function(comparator, _all, _until) {
        return filtered(cash(unique(pluck(this, 'previousElementSibling', _all, _until))), comparator);
    };
    fn.prevAll = function(comparator) {
        return this.prev(comparator, true);
    };
    fn.prevUntil = function(until, comparator) {
        return this.prev(comparator, true, until);
    };
    fn.map = function(callback) {
        return cash(concat.apply([], map.call(this, function(ele, i) {
            return callback.call(ele, i, ele);
        })));
    };
    fn.clone = function() {
        return this.map(function(i, ele) {
            return ele.cloneNode(true);
        });
    };
    fn.offsetParent = function() {
        return this.map(function(i, ele) {
            var offsetParent = ele.offsetParent;
            while(offsetParent && computeStyle(offsetParent, 'position') === 'static')offsetParent = offsetParent.offsetParent;
            return offsetParent || docEle;
        });
    };
    fn.slice = function(start, end) {
        return cash(slice.call(this, start, end));
    };
    // @require ./cash.ts
    var dashAlphaRe = /-([a-z])/g;
    function camelCase(str) {
        return str.replace(dashAlphaRe, function(match, letter) {
            return letter.toUpperCase();
        });
    }
    fn.ready = function(callback) {
        var cb = function() {
            return setTimeout(callback, 0, cash);
        };
        if (doc.readyState !== 'loading') cb();
        else doc.addEventListener('DOMContentLoaded', cb);
        return this;
    };
    fn.unwrap = function() {
        this.parent().each(function(i, ele) {
            if (ele.tagName === 'BODY') return;
            var $ele = cash(ele);
            $ele.replaceWith($ele.children());
        });
        return this;
    };
    fn.offset = function() {
        var ele = this[0];
        if (!ele) return;
        var rect = ele.getBoundingClientRect();
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    };
    fn.position = function() {
        var ele = this[0];
        if (!ele) return;
        var isFixed = computeStyle(ele, 'position') === 'fixed';
        var offset = isFixed ? ele.getBoundingClientRect() : this.offset();
        if (!isFixed) {
            var doc_1 = ele.ownerDocument;
            var offsetParent = ele.offsetParent || doc_1.documentElement;
            while((offsetParent === doc_1.body || offsetParent === doc_1.documentElement) && computeStyle(offsetParent, 'position') === 'static')offsetParent = offsetParent.parentNode;
            if (offsetParent !== ele && isElement(offsetParent)) {
                var parentOffset = cash(offsetParent).offset();
                offset.top -= parentOffset.top + computeStyleInt(offsetParent, 'borderTopWidth');
                offset.left -= parentOffset.left + computeStyleInt(offsetParent, 'borderLeftWidth');
            }
        }
        return {
            top: offset.top - computeStyleInt(ele, 'marginTop'),
            left: offset.left - computeStyleInt(ele, 'marginLeft')
        };
    };
    var propMap = {
        /* GENERAL */ class: 'className',
        contenteditable: 'contentEditable',
        /* LABEL */ for: 'htmlFor',
        /* INPUT */ readonly: 'readOnly',
        maxlength: 'maxLength',
        tabindex: 'tabIndex',
        /* TABLE */ colspan: 'colSpan',
        rowspan: 'rowSpan',
        /* IMAGE */ usemap: 'useMap'
    };
    fn.prop = function(prop, value) {
        if (!prop) return;
        if (isString(prop)) {
            prop = propMap[prop] || prop;
            if (arguments.length < 2) return this[0] && this[0][prop];
            return this.each(function(i, ele) {
                ele[prop] = value;
            });
        }
        for(var key in prop)this.prop(key, prop[key]);
        return this;
    };
    fn.removeProp = function(prop) {
        return this.each(function(i, ele) {
            delete ele[propMap[prop] || prop];
        });
    };
    var cssVariableRe = /^--/;
    // @require ./variables.ts
    function isCSSVariable(prop) {
        return cssVariableRe.test(prop);
    }
    // @require core/camel_case.ts
    // @require core/cash.ts
    // @require core/each.ts
    // @require core/variables.ts
    // @require ./is_css_variable.ts
    var prefixedProps = {};
    var style = div.style;
    var vendorsPrefixes = [
        'webkit',
        'moz',
        'ms'
    ];
    function getPrefixedProp(prop, isVariable) {
        if (isVariable === void 0) isVariable = isCSSVariable(prop);
        if (isVariable) return prop;
        if (!prefixedProps[prop]) {
            var propCC = camelCase(prop);
            var propUC = "".concat(propCC[0].toUpperCase()).concat(propCC.slice(1));
            var props = "".concat(propCC, " ").concat(vendorsPrefixes.join("".concat(propUC, " "))).concat(propUC).split(' ');
            each(props, function(i, p) {
                if (p in style) {
                    prefixedProps[prop] = p;
                    return false;
                }
            });
        }
        return prefixedProps[prop];
    }
    // @require core/type_checking.ts
    // @require ./is_css_variable.ts
    var numericProps = {
        animationIterationCount: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gridArea: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnStart: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowStart: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        widows: true,
        zIndex: true
    };
    function getSuffixedValue(prop, value, isVariable) {
        if (isVariable === void 0) isVariable = isCSSVariable(prop);
        return !isVariable && !numericProps[prop] && isNumeric(value) ? "".concat(value, "px") : value;
    }
    function css(prop, value) {
        if (isString(prop)) {
            var isVariable_1 = isCSSVariable(prop);
            prop = getPrefixedProp(prop, isVariable_1);
            if (arguments.length < 2) return this[0] && computeStyle(this[0], prop, isVariable_1);
            if (!prop) return this;
            value = getSuffixedValue(prop, value, isVariable_1);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                if (isVariable_1) ele.style.setProperty(prop, value);
                else ele.style[prop] = value;
            });
        }
        for(var key in prop)this.css(key, prop[key]);
        return this;
    }
    fn.css = css;
    function attempt(fn, arg) {
        try {
            return fn(arg);
        } catch (_a) {
            return arg;
        }
    }
    // @require core/attempt.ts
    // @require core/camel_case.ts
    var JSONStringRe = /^\s+|\s+$/;
    function getData(ele, key) {
        var value = ele.dataset[key] || ele.dataset[camelCase(key)];
        if (JSONStringRe.test(value)) return value;
        return attempt(JSON.parse, value);
    }
    // @require core/attempt.ts
    // @require core/camel_case.ts
    function setData(ele, key, value) {
        value = attempt(JSON.stringify, value);
        ele.dataset[camelCase(key)] = value;
    }
    function data(name, value) {
        if (!name) {
            if (!this[0]) return;
            var datas = {};
            for(var key in this[0].dataset)datas[key] = getData(this[0], key);
            return datas;
        }
        if (isString(name)) {
            if (arguments.length < 2) return this[0] && getData(this[0], name);
            if (isUndefined(value)) return this;
            return this.each(function(i, ele) {
                setData(ele, name, value);
            });
        }
        for(var key in name)this.data(key, name[key]);
        return this;
    }
    fn.data = data;
    function getDocumentDimension(doc, dimension) {
        var docEle = doc.documentElement;
        return Math.max(doc.body["scroll".concat(dimension)], docEle["scroll".concat(dimension)], doc.body["offset".concat(dimension)], docEle["offset".concat(dimension)], docEle["client".concat(dimension)]);
    }
    each([
        true,
        false
    ], function(i, outer) {
        each([
            'Width',
            'Height'
        ], function(i, prop) {
            var name = "".concat(outer ? 'outer' : 'inner').concat(prop);
            fn[name] = function(includeMargins) {
                if (!this[0]) return;
                if (isWindow(this[0])) return outer ? this[0]["inner".concat(prop)] : this[0].document.documentElement["client".concat(prop)];
                if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
                return this[0]["".concat(outer ? 'offset' : 'client').concat(prop)] + (includeMargins && outer ? computeStyleInt(this[0], "margin".concat(i ? 'Top' : 'Left')) + computeStyleInt(this[0], "margin".concat(i ? 'Bottom' : 'Right')) : 0);
            };
        });
    });
    each([
        'Width',
        'Height'
    ], function(index, prop) {
        var propLC = prop.toLowerCase();
        fn[propLC] = function(value) {
            if (!this[0]) return isUndefined(value) ? undefined : this;
            if (!arguments.length) {
                if (isWindow(this[0])) return this[0].document.documentElement["client".concat(prop)];
                if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
                return this[0].getBoundingClientRect()[propLC] - getExtraSpace(this[0], !index);
            }
            var valueNumber = parseInt(value, 10);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                var boxSizing = computeStyle(ele, 'boxSizing');
                ele.style[propLC] = getSuffixedValue(propLC, valueNumber + (boxSizing === 'border-box' ? getExtraSpace(ele, !index) : 0));
            });
        };
    });
    var displayProperty = '___cd';
    fn.toggle = function(force) {
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            var hidden = isHidden(ele);
            var show = isUndefined(force) ? hidden : force;
            if (show) {
                ele.style.display = ele[displayProperty] || '';
                if (isHidden(ele)) ele.style.display = getDefaultDisplay(ele.tagName);
            } else if (!hidden) {
                ele[displayProperty] = computeStyle(ele, 'display');
                ele.style.display = 'none';
            }
        });
    };
    fn.hide = function() {
        return this.toggle(false);
    };
    fn.show = function() {
        return this.toggle(true);
    };
    var eventsNamespace = '___ce';
    var eventsNamespacesSeparator = '.';
    var eventsFocus = {
        focus: 'focusin',
        blur: 'focusout'
    };
    var eventsHover = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    var eventsMouseRe = /^(mouse|pointer|contextmenu|drag|drop|click|dblclick)/i;
    // @require ./variables.ts
    function getEventNameBubbling(name) {
        return eventsHover[name] || eventsFocus[name] || name;
    }
    // @require ./variables.ts
    function parseEventName(eventName) {
        var parts = eventName.split(eventsNamespacesSeparator);
        return [
            parts[0],
            parts.slice(1).sort()
        ]; // [name, namespace[]]
    }
    fn.trigger = function(event, data) {
        if (isString(event)) {
            var _a = parseEventName(event), nameOriginal = _a[0], namespaces = _a[1];
            var name_1 = getEventNameBubbling(nameOriginal);
            if (!name_1) return this;
            var type = eventsMouseRe.test(name_1) ? 'MouseEvents' : 'HTMLEvents';
            event = doc.createEvent(type);
            event.initEvent(name_1, true, true);
            event.namespace = namespaces.join(eventsNamespacesSeparator);
            event.___ot = nameOriginal;
        }
        event.___td = data;
        var isEventFocus = event.___ot in eventsFocus;
        return this.each(function(i, ele) {
            if (isEventFocus && isFunction(ele[event.___ot])) {
                ele["___i".concat(event.type)] = true; // Ensuring the native event is ignored
                ele[event.___ot]();
                ele["___i".concat(event.type)] = false; // Ensuring the custom event is not ignored
            }
            ele.dispatchEvent(event);
        });
    };
    // @require ./variables.ts
    function getEventsCache(ele) {
        return ele[eventsNamespace] = ele[eventsNamespace] || {};
    }
    // @require core/guid.ts
    // @require events/helpers/get_events_cache.ts
    function addEvent(ele, name, namespaces, selector, callback) {
        var eventCache = getEventsCache(ele);
        eventCache[name] = eventCache[name] || [];
        eventCache[name].push([
            namespaces,
            selector,
            callback
        ]);
        ele.addEventListener(name, callback);
    }
    function hasNamespaces(ns1, ns2) {
        return !ns2 || !some.call(ns2, function(ns) {
            return ns1.indexOf(ns) < 0;
        });
    }
    // @require ./get_events_cache.ts
    // @require ./has_namespaces.ts
    // @require ./parse_event_name.ts
    function removeEvent(ele, name, namespaces, selector, callback) {
        var cache = getEventsCache(ele);
        if (!name) for(name in cache)removeEvent(ele, name, namespaces, selector, callback);
        else if (cache[name]) cache[name] = cache[name].filter(function(_a) {
            var ns = _a[0], sel = _a[1], cb = _a[2];
            if (callback && cb.guid !== callback.guid || !hasNamespaces(ns, namespaces) || selector && selector !== sel) return true;
            ele.removeEventListener(name, cb);
        });
    }
    fn.off = function(eventFullName, selector, callback) {
        var _this = this;
        if (isUndefined(eventFullName)) this.each(function(i, ele) {
            if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
            removeEvent(ele);
        });
        else if (!isString(eventFullName)) for(var key in eventFullName)this.off(key, eventFullName[key]);
        else {
            if (isFunction(selector)) {
                callback = selector;
                selector = '';
            }
            each(getSplitValues(eventFullName), function(i, eventFullName) {
                var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
                var name = getEventNameBubbling(nameOriginal);
                _this.each(function(i, ele) {
                    if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
                    removeEvent(ele, name, namespaces, selector, callback);
                });
            });
        }
        return this;
    };
    fn.remove = function(comparator) {
        filtered(this, comparator).detach().off();
        return this;
    };
    fn.replaceWith = function(selector) {
        return this.before(selector).remove();
    };
    fn.replaceAll = function(selector) {
        cash(selector).replaceWith(this);
        return this;
    };
    function on(eventFullName, selector, data, callback, _one) {
        var _this = this;
        if (!isString(eventFullName)) {
            for(var key in eventFullName)this.on(key, selector, data, eventFullName[key], _one);
            return this;
        }
        if (!isString(selector)) {
            if (isUndefined(selector) || isNull(selector)) selector = '';
            else if (isUndefined(data)) {
                data = selector;
                selector = '';
            } else {
                callback = data;
                data = selector;
                selector = '';
            }
        }
        if (!isFunction(callback)) {
            callback = data;
            data = undefined;
        }
        if (!callback) return this;
        each(getSplitValues(eventFullName), function(i, eventFullName) {
            var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
            var name = getEventNameBubbling(nameOriginal);
            var isEventHover = nameOriginal in eventsHover;
            var isEventFocus = nameOriginal in eventsFocus;
            if (!name) return;
            _this.each(function(i, ele) {
                if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
                var finalCallback = function(event) {
                    if (event.target["___i".concat(event.type)]) return event.stopImmediatePropagation(); // Ignoring native event in favor of the upcoming custom one
                    if (event.namespace && !hasNamespaces(namespaces, event.namespace.split(eventsNamespacesSeparator))) return;
                    if (!selector && (isEventFocus && (event.target !== ele || event.___ot === name) || isEventHover && event.relatedTarget && ele.contains(event.relatedTarget))) return;
                    var thisArg = ele;
                    if (selector) {
                        var target = event.target;
                        while(!matches(target, selector)){
                            if (target === ele) return;
                            target = target.parentNode;
                            if (!target) return;
                        }
                        thisArg = target;
                    }
                    Object.defineProperty(event, 'currentTarget', {
                        configurable: true,
                        get: function() {
                            return thisArg;
                        }
                    });
                    Object.defineProperty(event, 'delegateTarget', {
                        configurable: true,
                        get: function() {
                            return ele;
                        }
                    });
                    Object.defineProperty(event, 'data', {
                        configurable: true,
                        get: function() {
                            return data;
                        }
                    });
                    var returnValue = callback.call(thisArg, event, event.___td);
                    if (_one) removeEvent(ele, name, namespaces, selector, finalCallback);
                    if (returnValue === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                finalCallback.guid = callback.guid = callback.guid || cash.guid++;
                addEvent(ele, name, namespaces, selector, finalCallback);
            });
        });
        return this;
    }
    fn.on = on;
    function one(eventFullName, selector, data, callback) {
        return this.on(eventFullName, selector, data, callback, true);
    }
    fn.one = one;
    var queryEncodeCRLFRe = /\r?\n/g;
    function queryEncode(prop, value) {
        return "&".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent(value.replace(queryEncodeCRLFRe, '\r\n')));
    }
    var skippableRe = /file|reset|submit|button|image/i;
    var checkableRe = /radio|checkbox/i;
    fn.serialize = function() {
        var query = '';
        this.each(function(i, ele) {
            each(ele.elements || [
                ele
            ], function(i, ele) {
                if (ele.disabled || !ele.name || ele.tagName === 'FIELDSET' || skippableRe.test(ele.type) || checkableRe.test(ele.type) && !ele.checked) return;
                var value = getValue(ele);
                if (!isUndefined(value)) {
                    var values = isArray(value) ? value : [
                        value
                    ];
                    each(values, function(i, value) {
                        query += queryEncode(ele.name, value);
                    });
                }
            });
        });
        return query.slice(1);
    };
    $59c4f5e8925f3128$exports = cash;
})();


var $5002af504f38f331$exports = {};
/**
 * @author emmanuelolaojo
 * @since 11/10/18
 *
 * The MagicGrid class is an
 * implementation of a flexible
 * grid layout.
 */ var $02934531637c3cc4$exports = {};
var $b98070c879ea7b49$exports = {};
class $b98070c879ea7b49$var$Listener {
    /*
     Listener class holds the event,
     handler and a unique id
     */ id;
    event;
    handler;
    constructor(id, event, handler){
        this.id = id;
        this.event = event;
        this.handler = handler;
    }
}
$b98070c879ea7b49$exports = $b98070c879ea7b49$var$Listener;


class $02934531637c3cc4$var$EventEmitter {
    listeners;
    #idCounter;
    constructor(){
        this.listeners = [];
        this.#idCounter = 0;
    }
    removeListener(id) {
        const i = this.listeners.findIndex((listener)=>listener.id === id);
        if (i !== -1) {
            this.listeners.splice(i, 1);
            return true;
        }
        return false;
    }
    addListener(event, handler) {
        let id = this.#idCounter++;
        this.listeners.push(new $b98070c879ea7b49$exports(id, event, handler));
        return id;
    }
    emit(event, payload) {
        for (const listener of this.listeners)if (listener.event === event) listener.handler(payload);
    }
}
$02934531637c3cc4$exports = $02934531637c3cc4$var$EventEmitter;


var $422d2d3629a6e2e3$exports = {};
/**
 * @author emmanuelolaojo
 * @since 11/11/18
 */ /**
 * Validates the configuration object.
 *
 * @param config - configuration object
 */ const $422d2d3629a6e2e3$var$checkParams = (config)=>{
    const DEFAULT_GUTTER = 25;
    const booleanProps = [
        "useTransform",
        "center"
    ];
    if (!config) throw new Error("No config object has been provided.");
    for (let prop of booleanProps)if (typeof config[prop] !== "boolean") config[prop] = true;
    if (typeof config.gutter !== "number") config.gutter = DEFAULT_GUTTER;
    if (!config.container) $422d2d3629a6e2e3$var$error("container");
    if (!config.items && !config.static) $422d2d3629a6e2e3$var$error("items or static");
};
/**
 * Handles invalid configuration object
 * errors.
 *
 * @param prop - a property with a missing value
 */ const $422d2d3629a6e2e3$var$error = (prop)=>{
    throw new Error(`Missing property '${prop}' in MagicGrid config`);
};
/**
 * Finds the shortest column in
 * a column list.
 *
 * @param cols - list of columns
 *
 * @return shortest column
 */ const $422d2d3629a6e2e3$var$getMin = (cols)=>{
    let min = cols[0];
    for (let col of cols)if (col.height < min.height) min = col;
    return min;
};
$422d2d3629a6e2e3$exports = {
    checkParams: $422d2d3629a6e2e3$var$checkParams,
    getMin: $422d2d3629a6e2e3$var$getMin
};


var $5002af504f38f331$require$checkParams = $422d2d3629a6e2e3$exports.checkParams;
var $5002af504f38f331$require$getMin = $422d2d3629a6e2e3$exports.getMin;
var $95c9425d523847ec$exports = {};
$95c9425d523847ec$exports = {
    POSITIONING_COMPLETE_EVENT: "positionComplete",
    REPOSITIONING_DELAY: 200
};


var $5002af504f38f331$require$POSITIONING_COMPLETE_EVENT = $95c9425d523847ec$exports.POSITIONING_COMPLETE_EVENT;
var $5002af504f38f331$require$REPOSITIONING_DELAY = $95c9425d523847ec$exports.REPOSITIONING_DELAY;
class $5002af504f38f331$var$MagicGrid extends $02934531637c3cc4$exports {
    /**
   * Initializes the necessary variables
   * for a magic grid.
   *
   * @param config - configuration object
   */ constructor(config){
        super();
        $5002af504f38f331$require$checkParams(config);
        if (config.container instanceof HTMLElement) {
            this.container = config.container;
            this.containerClass = config.container.className;
        } else {
            this.containerClass = config.container;
            this.container = document.querySelector(config.container);
        }
        this.static = config.static || false;
        this.size = config.items;
        this.gutter = config.gutter;
        this.maxColumns = config.maxColumns || false;
        this.useMin = config.useMin || false;
        this.useTransform = config.useTransform;
        this.animate = config.animate || false;
        this.center = config.center;
        this.styledItems = new Set();
        this.resizeObserver = null;
        this.isPositioning = false;
    }
    /**
   * Set a new container. Useful in cases where
   * the container reference changes for any reason.
   *
   * @param container {HTMLElement}
   */ setContainer(container) {
        const previousContainer = this.container;
        this.container = container;
        this.resizeObserver.unobserve(previousContainer);
        this.resizeObserver.observe(container);
    }
    /**
   * Initializes styles
   *
   * @private
   */ initStyles() {
        if (!this.ready()) return;
        this.container.style.position = "relative";
        const items = this.items();
        for(let i = 0; i < items.length; i++){
            if (this.styledItems.has(items[i])) continue;
            let style = items[i].style;
            style.position = "absolute";
            if (this.animate) style.transition = `${this.useTransform ? "transform" : "top, left"} 0.2s ease`;
            this.styledItems.add(items[i]);
        }
    }
    /**
   * Gets a collection of all items in a grid.
   *
   * @return {HTMLCollection}
   * @private
   */ items() {
        return this.container.children;
    }
    /**
   * Calculates the width of a column.
   *
   * @return width of a column in the grid
   * @private
   */ colWidth() {
        return this.items()[0].getBoundingClientRect().width + this.gutter;
    }
    /**
   * Initializes an array of empty columns
   * and calculates the leftover whitespace.
   *
   * @return {{cols: Array, wSpace: number}}
   * @private
   */ setup() {
        let width = this.container.getBoundingClientRect().width;
        let colWidth = this.colWidth();
        let numCols = Math.floor(width / colWidth) || 1;
        let cols = [];
        if (this.maxColumns && numCols > this.maxColumns) numCols = this.maxColumns;
        for(let i = 0; i < numCols; i++)cols[i] = {
            height: 0,
            index: i
        };
        let wSpace = width - numCols * colWidth + this.gutter;
        return {
            cols: cols,
            wSpace: wSpace
        };
    }
    /**
   * Gets the next available column.
   *
   * @param cols list of columns
   * @param i index of dom element
   *
   * @return {*} next available column
   * @private
   */ nextCol(cols, i) {
        if (this.useMin) return $5002af504f38f331$require$getMin(cols);
        return cols[i % cols.length];
    }
    /**
   * Positions each item in the grid, based
   * on their corresponding column's height
   * and index then stretches the container to
   * the height of the grid.
   */ positionItems() {
        if (this.isPositioning) return;
        this.isPositioning = true;
        let { cols: cols, wSpace: wSpace } = this.setup();
        let maxHeight = 0;
        let colWidth = this.colWidth();
        let items = this.items();
        wSpace = this.center ? Math.floor(wSpace / 2) : 0;
        this.initStyles();
        for(let i = 0; i < items.length; i++){
            let col = this.nextCol(cols, i);
            let item = items[i];
            let topGutter = col.height ? this.gutter : 0;
            let left = col.index * colWidth + wSpace + "px";
            let top = col.height + topGutter + "px";
            if (this.useTransform) item.style.transform = `translate(${left}, ${top})`;
            else {
                item.style.top = top;
                item.style.left = left;
            }
            col.height += item.getBoundingClientRect().height + topGutter;
            if (col.height > maxHeight) maxHeight = col.height;
        }
        this.container.style.height = maxHeight + this.gutter + "px";
        this.isPositioning = false;
        this.emit($5002af504f38f331$require$POSITIONING_COMPLETE_EVENT);
    }
    /**
   * Checks if every item has been loaded
   * in the dom.
   *
   * @return {Boolean} true if every item is present
   */ ready() {
        if (this.static) return true;
        return this.items().length >= this.size;
    }
    /**
   * Periodically checks that all items
   * have been loaded in the dom. Calls
   * this.listen() once all the items are
   * present.
   *
   * @private
   */ getReady() {
        let interval = setInterval(()=>{
            this.container = document.querySelector(this.containerClass);
            if (this.ready()) {
                clearInterval(interval);
                this.listen();
            }
        }, 100);
    }
    observeContainerResize() {
        if (this.resizeObserver) return;
        this.resizeObserver = new ResizeObserver(()=>{
            setTimeout(()=>{
                this.positionItems();
            }, $5002af504f38f331$require$REPOSITIONING_DELAY);
        });
        this.resizeObserver.observe(this.container);
    }
    /**
   * Positions all the items and
   * repositions them whenever the
   * window size changes.
   */ listen() {
        if (this.ready()) {
            window.addEventListener("resize", ()=>{
                setTimeout(()=>{
                    this.positionItems();
                }, $5002af504f38f331$require$REPOSITIONING_DELAY);
            });
            this.observeContainerResize();
            this.positionItems();
        } else this.getReady();
    }
    onPositionComplete(callback) {
        return this.addListener($5002af504f38f331$require$POSITIONING_COMPLETE_EVENT, callback);
    }
}
$5002af504f38f331$exports = $5002af504f38f331$var$MagicGrid;


function $ca9ce22b174df7eb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ca9ce22b174df7eb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ca9ce22b174df7eb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ca9ce22b174df7eb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $ca9ce22b174df7eb$var$CREATED = 1;
var $ca9ce22b174df7eb$var$MOUNTED = 2;
var $ca9ce22b174df7eb$var$IDLE = 3;
var $ca9ce22b174df7eb$var$MOVING = 4;
var $ca9ce22b174df7eb$var$SCROLLING = 5;
var $ca9ce22b174df7eb$var$DRAGGING = 6;
var $ca9ce22b174df7eb$var$DESTROYED = 7;
var $ca9ce22b174df7eb$var$STATES = {
    CREATED: $ca9ce22b174df7eb$var$CREATED,
    MOUNTED: $ca9ce22b174df7eb$var$MOUNTED,
    IDLE: $ca9ce22b174df7eb$var$IDLE,
    MOVING: $ca9ce22b174df7eb$var$MOVING,
    SCROLLING: $ca9ce22b174df7eb$var$SCROLLING,
    DRAGGING: $ca9ce22b174df7eb$var$DRAGGING,
    DESTROYED: $ca9ce22b174df7eb$var$DESTROYED
};
function $ca9ce22b174df7eb$var$empty(array) {
    array.length = 0;
}
function $ca9ce22b174df7eb$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $ca9ce22b174df7eb$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($ca9ce22b174df7eb$var$slice(arguments, 1)));
}
var $ca9ce22b174df7eb$var$nextTick = setTimeout;
var $ca9ce22b174df7eb$var$noop = function noop() {};
function $ca9ce22b174df7eb$var$raf(func) {
    return requestAnimationFrame(func);
}
function $ca9ce22b174df7eb$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $ca9ce22b174df7eb$var$isObject(subject) {
    return !$ca9ce22b174df7eb$var$isNull(subject) && $ca9ce22b174df7eb$var$typeOf("object", subject);
}
var $ca9ce22b174df7eb$var$isArray = Array.isArray;
var $ca9ce22b174df7eb$var$isFunction = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "function");
var $ca9ce22b174df7eb$var$isString = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "string");
var $ca9ce22b174df7eb$var$isUndefined = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "undefined");
function $ca9ce22b174df7eb$var$isNull(subject) {
    return subject === null;
}
function $ca9ce22b174df7eb$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $ca9ce22b174df7eb$var$toArray(value) {
    return $ca9ce22b174df7eb$var$isArray(value) ? value : [
        value
    ];
}
function $ca9ce22b174df7eb$var$forEach(values, iteratee) {
    $ca9ce22b174df7eb$var$toArray(values).forEach(iteratee);
}
function $ca9ce22b174df7eb$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $ca9ce22b174df7eb$var$push(array, items) {
    array.push.apply(array, $ca9ce22b174df7eb$var$toArray(items));
    return array;
}
function $ca9ce22b174df7eb$var$toggleClass(elm, classes, add) {
    if (elm) $ca9ce22b174df7eb$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $ca9ce22b174df7eb$var$addClass(elm, classes) {
    $ca9ce22b174df7eb$var$toggleClass(elm, $ca9ce22b174df7eb$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $ca9ce22b174df7eb$var$append(parent, children) {
    $ca9ce22b174df7eb$var$forEach(children, parent.appendChild.bind(parent));
}
function $ca9ce22b174df7eb$var$before(nodes, ref) {
    $ca9ce22b174df7eb$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $ca9ce22b174df7eb$var$matches(elm, selector) {
    return $ca9ce22b174df7eb$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $ca9ce22b174df7eb$var$children(parent, selector) {
    var children2 = parent ? $ca9ce22b174df7eb$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $ca9ce22b174df7eb$var$matches(child, selector);
    }) : children2;
}
function $ca9ce22b174df7eb$var$child(parent, selector) {
    return selector ? $ca9ce22b174df7eb$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $ca9ce22b174df7eb$var$ownKeys = Object.keys;
function $ca9ce22b174df7eb$var$forOwn(object, iteratee, right) {
    if (object) (right ? $ca9ce22b174df7eb$var$ownKeys(object).reverse() : $ca9ce22b174df7eb$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $ca9ce22b174df7eb$var$assign(object) {
    $ca9ce22b174df7eb$var$slice(arguments, 1).forEach(function(source) {
        $ca9ce22b174df7eb$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $ca9ce22b174df7eb$var$merge(object) {
    $ca9ce22b174df7eb$var$slice(arguments, 1).forEach(function(source) {
        $ca9ce22b174df7eb$var$forOwn(source, function(value, key) {
            if ($ca9ce22b174df7eb$var$isArray(value)) object[key] = value.slice();
            else if ($ca9ce22b174df7eb$var$isObject(value)) object[key] = $ca9ce22b174df7eb$var$merge({}, $ca9ce22b174df7eb$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $ca9ce22b174df7eb$var$omit(object, keys) {
    $ca9ce22b174df7eb$var$forEach(keys || $ca9ce22b174df7eb$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $ca9ce22b174df7eb$var$removeAttribute(elms, attrs) {
    $ca9ce22b174df7eb$var$forEach(elms, function(elm) {
        $ca9ce22b174df7eb$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $ca9ce22b174df7eb$var$setAttribute(elms, attrs, value) {
    if ($ca9ce22b174df7eb$var$isObject(attrs)) $ca9ce22b174df7eb$var$forOwn(attrs, function(value2, name) {
        $ca9ce22b174df7eb$var$setAttribute(elms, name, value2);
    });
    else $ca9ce22b174df7eb$var$forEach(elms, function(elm) {
        $ca9ce22b174df7eb$var$isNull(value) || value === "" ? $ca9ce22b174df7eb$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $ca9ce22b174df7eb$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $ca9ce22b174df7eb$var$isString(attrs) ? $ca9ce22b174df7eb$var$addClass(elm, attrs) : $ca9ce22b174df7eb$var$setAttribute(elm, attrs);
    parent && $ca9ce22b174df7eb$var$append(parent, elm);
    return elm;
}
function $ca9ce22b174df7eb$var$style(elm, prop, value) {
    if ($ca9ce22b174df7eb$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$ca9ce22b174df7eb$var$isNull(value)) elm.style[prop] = "" + value;
}
function $ca9ce22b174df7eb$var$display(elm, display2) {
    $ca9ce22b174df7eb$var$style(elm, "display", display2);
}
function $ca9ce22b174df7eb$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $ca9ce22b174df7eb$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $ca9ce22b174df7eb$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $ca9ce22b174df7eb$var$rect(target) {
    return target.getBoundingClientRect();
}
function $ca9ce22b174df7eb$var$remove(nodes) {
    $ca9ce22b174df7eb$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $ca9ce22b174df7eb$var$parseHtml(html) {
    return $ca9ce22b174df7eb$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $ca9ce22b174df7eb$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $ca9ce22b174df7eb$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $ca9ce22b174df7eb$var$queryAll(parent, selector) {
    return selector ? $ca9ce22b174df7eb$var$slice(parent.querySelectorAll(selector)) : [];
}
function $ca9ce22b174df7eb$var$removeClass(elm, classes) {
    $ca9ce22b174df7eb$var$toggleClass(elm, classes, false);
}
function $ca9ce22b174df7eb$var$timeOf(e) {
    return e.timeStamp;
}
function $ca9ce22b174df7eb$var$unit(value) {
    return $ca9ce22b174df7eb$var$isString(value) ? value : value ? value + "px" : "";
}
var $ca9ce22b174df7eb$var$PROJECT_CODE = "splide";
var $ca9ce22b174df7eb$var$DATA_ATTRIBUTE = "data-" + $ca9ce22b174df7eb$var$PROJECT_CODE;
function $ca9ce22b174df7eb$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $ca9ce22b174df7eb$var$PROJECT_CODE + "] " + (message || ""));
}
var $ca9ce22b174df7eb$var$min = Math.min, $ca9ce22b174df7eb$var$max = Math.max, $ca9ce22b174df7eb$var$floor = Math.floor, $ca9ce22b174df7eb$var$ceil = Math.ceil, $ca9ce22b174df7eb$var$abs = Math.abs;
function $ca9ce22b174df7eb$var$approximatelyEqual(x, y, epsilon) {
    return $ca9ce22b174df7eb$var$abs(x - y) < epsilon;
}
function $ca9ce22b174df7eb$var$between(number, x, y, exclusive) {
    var minimum = $ca9ce22b174df7eb$var$min(x, y);
    var maximum = $ca9ce22b174df7eb$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $ca9ce22b174df7eb$var$clamp(number, x, y) {
    var minimum = $ca9ce22b174df7eb$var$min(x, y);
    var maximum = $ca9ce22b174df7eb$var$max(x, y);
    return $ca9ce22b174df7eb$var$min($ca9ce22b174df7eb$var$max(minimum, number), maximum);
}
function $ca9ce22b174df7eb$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $ca9ce22b174df7eb$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $ca9ce22b174df7eb$var$format(string, replacements) {
    $ca9ce22b174df7eb$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $ca9ce22b174df7eb$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $ca9ce22b174df7eb$var$ids = {};
function $ca9ce22b174df7eb$var$uniqueId(prefix) {
    return "" + prefix + $ca9ce22b174df7eb$var$pad($ca9ce22b174df7eb$var$ids[prefix] = ($ca9ce22b174df7eb$var$ids[prefix] || 0) + 1);
}
function $ca9ce22b174df7eb$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $ca9ce22b174df7eb$var$forEach(targets, function(target) {
            target && $ca9ce22b174df7eb$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $ca9ce22b174df7eb$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $ca9ce22b174df7eb$export$d300dc1a2634364b = "mounted";
var $ca9ce22b174df7eb$export$d8dac49b4532735a = "ready";
var $ca9ce22b174df7eb$export$2aa493d7c3275167 = "move";
var $ca9ce22b174df7eb$export$fe5802204b967f0d = "moved";
var $ca9ce22b174df7eb$export$5adb665701eda1ce = "click";
var $ca9ce22b174df7eb$export$92e3eae133acac4c = "active";
var $ca9ce22b174df7eb$export$6bcbb81035c12cea = "inactive";
var $ca9ce22b174df7eb$export$6a5b3445e4066a53 = "visible";
var $ca9ce22b174df7eb$export$8c5c7a21d54563e9 = "hidden";
var $ca9ce22b174df7eb$export$7f4701ac5e05e39f = "refresh";
var $ca9ce22b174df7eb$export$db40ab7c0855fa5c = "updated";
var $ca9ce22b174df7eb$export$7e019dae5103a285 = "resize";
var $ca9ce22b174df7eb$export$d637eba1e9e28482 = "resized";
var $ca9ce22b174df7eb$export$e84bf5065c9087ac = "drag";
var $ca9ce22b174df7eb$export$8e9f636d2c722196 = "dragging";
var $ca9ce22b174df7eb$export$90ea576bd3fdeb60 = "dragged";
var $ca9ce22b174df7eb$export$49801896908b5e33 = "scroll";
var $ca9ce22b174df7eb$export$ff8164bff3202b9 = "scrolled";
var $ca9ce22b174df7eb$export$6cbac5b662a31e1b = "overflow";
var $ca9ce22b174df7eb$export$88c4cf7419e470cd = "destroy";
var $ca9ce22b174df7eb$export$8647f6b043e04e9d = "arrows:mounted";
var $ca9ce22b174df7eb$export$d467f9343b961f75 = "arrows:updated";
var $ca9ce22b174df7eb$export$bf89a4e4349c9778 = "pagination:mounted";
var $ca9ce22b174df7eb$export$eb2019082ed6de0b = "pagination:updated";
var $ca9ce22b174df7eb$export$84015c33508f94ec = "navigation:mounted";
var $ca9ce22b174df7eb$export$23663268a31b79e2 = "autoplay:play";
var $ca9ce22b174df7eb$export$185723258309b608 = "autoplay:playing";
var $ca9ce22b174df7eb$export$16a1e4f3d0368265 = "autoplay:pause";
var $ca9ce22b174df7eb$export$9f64346e17f0ec8e = "lazyload:loaded";
var $ca9ce22b174df7eb$export$6d5af59619d10e6a = "sk";
var $ca9ce22b174df7eb$export$f0af896383d5adff = "sh";
var $ca9ce22b174df7eb$export$28dea85f216954dc = "ei";
function $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $ca9ce22b174df7eb$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $ca9ce22b174df7eb$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $ca9ce22b174df7eb$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $ca9ce22b174df7eb$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($ca9ce22b174df7eb$export$88c4cf7419e470cd, binder.destroy);
    return $ca9ce22b174df7eb$var$assign(binder, {
        bus: bus,
        on: on,
        off: $ca9ce22b174df7eb$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $ca9ce22b174df7eb$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $ca9ce22b174df7eb$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $ca9ce22b174df7eb$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $ca9ce22b174df7eb$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $ca9ce22b174df7eb$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $ca9ce22b174df7eb$export$efff0f5979573c99(func, duration) {
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $ca9ce22b174df7eb$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $ca9ce22b174df7eb$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $ca9ce22b174df7eb$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($ca9ce22b174df7eb$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $ca9ce22b174df7eb$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $ca9ce22b174df7eb$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $ca9ce22b174df7eb$var$merge(options, reducedMotion) : $ca9ce22b174df7eb$var$omit(options, $ca9ce22b174df7eb$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $ca9ce22b174df7eb$var$merge(options, opts);
        base && $ca9ce22b174df7eb$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($ca9ce22b174df7eb$var$CREATED)) Splide2.emit($ca9ce22b174df7eb$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $ca9ce22b174df7eb$var$ARROW = "Arrow";
var $ca9ce22b174df7eb$var$ARROW_LEFT = $ca9ce22b174df7eb$var$ARROW + "Left";
var $ca9ce22b174df7eb$var$ARROW_RIGHT = $ca9ce22b174df7eb$var$ARROW + "Right";
var $ca9ce22b174df7eb$var$ARROW_UP = $ca9ce22b174df7eb$var$ARROW + "Up";
var $ca9ce22b174df7eb$var$ARROW_DOWN = $ca9ce22b174df7eb$var$ARROW + "Down";
var $ca9ce22b174df7eb$export$373e92e0788ff06e = "ltr";
var $ca9ce22b174df7eb$export$850f7749a2909601 = "rtl";
var $ca9ce22b174df7eb$export$97170d9824b89709 = "ttb";
var $ca9ce22b174df7eb$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $ca9ce22b174df7eb$var$ARROW_UP,
        $ca9ce22b174df7eb$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $ca9ce22b174df7eb$var$ARROW_DOWN,
        $ca9ce22b174df7eb$var$ARROW_LEFT
    ]
};
function $ca9ce22b174df7eb$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $ca9ce22b174df7eb$export$850f7749a2909601 && !axisOnly ? 1 : direction === $ca9ce22b174df7eb$export$97170d9824b89709 ? 0 : -1;
        return $ca9ce22b174df7eb$var$ORIENTATION_MAP[prop] && $ca9ce22b174df7eb$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $ca9ce22b174df7eb$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $ca9ce22b174df7eb$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $ca9ce22b174df7eb$var$ROLE = "role";
var $ca9ce22b174df7eb$var$TAB_INDEX = "tabindex";
var $ca9ce22b174df7eb$var$DISABLED = "disabled";
var $ca9ce22b174df7eb$var$ARIA_PREFIX = "aria-";
var $ca9ce22b174df7eb$var$ARIA_CONTROLS = $ca9ce22b174df7eb$var$ARIA_PREFIX + "controls";
var $ca9ce22b174df7eb$var$ARIA_CURRENT = $ca9ce22b174df7eb$var$ARIA_PREFIX + "current";
var $ca9ce22b174df7eb$var$ARIA_SELECTED = $ca9ce22b174df7eb$var$ARIA_PREFIX + "selected";
var $ca9ce22b174df7eb$var$ARIA_LABEL = $ca9ce22b174df7eb$var$ARIA_PREFIX + "label";
var $ca9ce22b174df7eb$var$ARIA_LABELLEDBY = $ca9ce22b174df7eb$var$ARIA_PREFIX + "labelledby";
var $ca9ce22b174df7eb$var$ARIA_HIDDEN = $ca9ce22b174df7eb$var$ARIA_PREFIX + "hidden";
var $ca9ce22b174df7eb$var$ARIA_ORIENTATION = $ca9ce22b174df7eb$var$ARIA_PREFIX + "orientation";
var $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION = $ca9ce22b174df7eb$var$ARIA_PREFIX + "roledescription";
var $ca9ce22b174df7eb$var$ARIA_LIVE = $ca9ce22b174df7eb$var$ARIA_PREFIX + "live";
var $ca9ce22b174df7eb$var$ARIA_BUSY = $ca9ce22b174df7eb$var$ARIA_PREFIX + "busy";
var $ca9ce22b174df7eb$var$ARIA_ATOMIC = $ca9ce22b174df7eb$var$ARIA_PREFIX + "atomic";
var $ca9ce22b174df7eb$var$ALL_ATTRIBUTES = [
    $ca9ce22b174df7eb$var$ROLE,
    $ca9ce22b174df7eb$var$TAB_INDEX,
    $ca9ce22b174df7eb$var$DISABLED,
    $ca9ce22b174df7eb$var$ARIA_CONTROLS,
    $ca9ce22b174df7eb$var$ARIA_CURRENT,
    $ca9ce22b174df7eb$var$ARIA_LABEL,
    $ca9ce22b174df7eb$var$ARIA_LABELLEDBY,
    $ca9ce22b174df7eb$var$ARIA_HIDDEN,
    $ca9ce22b174df7eb$var$ARIA_ORIENTATION,
    $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION
];
var $ca9ce22b174df7eb$var$CLASS_PREFIX = $ca9ce22b174df7eb$var$PROJECT_CODE + "__";
var $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX = "is-";
var $ca9ce22b174df7eb$export$93b21159ad85c843 = $ca9ce22b174df7eb$var$PROJECT_CODE;
var $ca9ce22b174df7eb$export$7738b09ac0a98952 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "track";
var $ca9ce22b174df7eb$export$19cc2a5451235cae = $ca9ce22b174df7eb$var$CLASS_PREFIX + "list";
var $ca9ce22b174df7eb$export$8d922915837a38d3 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "slide";
var $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947 = $ca9ce22b174df7eb$export$8d922915837a38d3 + "--clone";
var $ca9ce22b174df7eb$export$e9ba7e444ba60a12 = $ca9ce22b174df7eb$export$8d922915837a38d3 + "__container";
var $ca9ce22b174df7eb$export$a26cbd955fecf11e = $ca9ce22b174df7eb$var$CLASS_PREFIX + "arrows";
var $ca9ce22b174df7eb$export$516e7d18e13a2dca = $ca9ce22b174df7eb$var$CLASS_PREFIX + "arrow";
var $ca9ce22b174df7eb$export$58ea3db24c33b76 = $ca9ce22b174df7eb$export$516e7d18e13a2dca + "--prev";
var $ca9ce22b174df7eb$export$4885afd7098a65c2 = $ca9ce22b174df7eb$export$516e7d18e13a2dca + "--next";
var $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "pagination";
var $ca9ce22b174df7eb$export$52f2cca6a5eee805 = $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 + "__page";
var $ca9ce22b174df7eb$export$4c82dc32b1c4ace5 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "progress";
var $ca9ce22b174df7eb$export$2c9b091c749f4409 = $ca9ce22b174df7eb$export$4c82dc32b1c4ace5 + "__bar";
var $ca9ce22b174df7eb$export$a29701deef84b825 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "toggle";
var $ca9ce22b174df7eb$export$d9d247d51b430dbb = $ca9ce22b174df7eb$export$a29701deef84b825 + "__play";
var $ca9ce22b174df7eb$export$3529f201a419925b = $ca9ce22b174df7eb$export$a29701deef84b825 + "__pause";
var $ca9ce22b174df7eb$export$3e5381ee3fab8374 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "spinner";
var $ca9ce22b174df7eb$export$bb78d7c200da8960 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "sr";
var $ca9ce22b174df7eb$export$7761661e2d5b9388 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "initialized";
var $ca9ce22b174df7eb$export$72d36ecf3758cb4b = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "active";
var $ca9ce22b174df7eb$export$e423ac4972f5e196 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "prev";
var $ca9ce22b174df7eb$export$457a2d20827a2779 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "next";
var $ca9ce22b174df7eb$export$53ca4621bbab9a = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "visible";
var $ca9ce22b174df7eb$export$d22ec4ccb7996ba2 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "loading";
var $ca9ce22b174df7eb$export$b6f202a162a09100 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "focus-in";
var $ca9ce22b174df7eb$export$cd908cd1dd625e29 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "overflow";
var $ca9ce22b174df7eb$export$49f9eaea10ebf193 = [
    $ca9ce22b174df7eb$export$72d36ecf3758cb4b,
    $ca9ce22b174df7eb$export$53ca4621bbab9a,
    $ca9ce22b174df7eb$export$e423ac4972f5e196,
    $ca9ce22b174df7eb$export$457a2d20827a2779,
    $ca9ce22b174df7eb$export$d22ec4ccb7996ba2,
    $ca9ce22b174df7eb$export$b6f202a162a09100,
    $ca9ce22b174df7eb$export$cd908cd1dd625e29
];
var $ca9ce22b174df7eb$export$ba41d43e4a419565 = {
    slide: $ca9ce22b174df7eb$export$8d922915837a38d3,
    clone: $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947,
    arrows: $ca9ce22b174df7eb$export$a26cbd955fecf11e,
    arrow: $ca9ce22b174df7eb$export$516e7d18e13a2dca,
    prev: $ca9ce22b174df7eb$export$58ea3db24c33b76,
    next: $ca9ce22b174df7eb$export$4885afd7098a65c2,
    pagination: $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3,
    page: $ca9ce22b174df7eb$export$52f2cca6a5eee805,
    spinner: $ca9ce22b174df7eb$export$3e5381ee3fab8374
};
function $ca9ce22b174df7eb$var$closest(from, selector) {
    if ($ca9ce22b174df7eb$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($ca9ce22b174df7eb$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $ca9ce22b174df7eb$var$FRICTION = 5;
var $ca9ce22b174df7eb$var$LOG_INTERVAL = 200;
var $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $ca9ce22b174df7eb$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $ca9ce22b174df7eb$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, destroy);
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, setup);
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, update);
        bind(document, $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $ca9ce22b174df7eb$var$toggleClass(root, $ca9ce22b174df7eb$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $ca9ce22b174df7eb$var$ALL_ATTRIBUTES.concat("style");
        $ca9ce22b174df7eb$var$empty(slides);
        $ca9ce22b174df7eb$var$removeClass(root, rootClasses);
        $ca9ce22b174df7eb$var$removeClass(track, trackClasses);
        $ca9ce22b174df7eb$var$removeAttribute([
            track,
            list
        ], attrs);
        $ca9ce22b174df7eb$var$removeAttribute(root, completely ? attrs : [
            "style",
            $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $ca9ce22b174df7eb$var$removeClass(root, rootClasses);
        $ca9ce22b174df7eb$var$removeClass(track, trackClasses);
        rootClasses = getClasses($ca9ce22b174df7eb$export$93b21159ad85c843);
        trackClasses = getClasses($ca9ce22b174df7eb$export$7738b09ac0a98952);
        $ca9ce22b174df7eb$var$addClass(root, rootClasses);
        $ca9ce22b174df7eb$var$addClass(track, trackClasses);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABEL, options.label);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $ca9ce22b174df7eb$export$7738b09ac0a98952);
        list = $ca9ce22b174df7eb$var$child(track, "." + $ca9ce22b174df7eb$export$19cc2a5451235cae);
        $ca9ce22b174df7eb$var$assert(track && list, "A track/list element is missing.");
        $ca9ce22b174df7eb$var$push(slides, $ca9ce22b174df7eb$var$children(list, "." + $ca9ce22b174df7eb$export$8d922915837a38d3 + ":not(." + $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947 + ")"));
        $ca9ce22b174df7eb$var$forOwn({
            arrows: $ca9ce22b174df7eb$export$a26cbd955fecf11e,
            pagination: $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3,
            prev: $ca9ce22b174df7eb$export$58ea3db24c33b76,
            next: $ca9ce22b174df7eb$export$4885afd7098a65c2,
            bar: $ca9ce22b174df7eb$export$2c9b091c749f4409,
            toggle: $ca9ce22b174df7eb$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $ca9ce22b174df7eb$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $ca9ce22b174df7eb$var$uniqueId($ca9ce22b174df7eb$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ROLE) && root.tagName !== "SECTION" && role) $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ROLE, role);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $ca9ce22b174df7eb$var$query(root, selector);
        return elm && $ca9ce22b174df7eb$var$closest(elm, "." + $ca9ce22b174df7eb$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $ca9ce22b174df7eb$export$93b21159ad85c843 && $ca9ce22b174df7eb$export$72d36ecf3758cb4b
        ];
    }
    return $ca9ce22b174df7eb$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $ca9ce22b174df7eb$export$e5a58a5ee5b54c22 = "slide";
var $ca9ce22b174df7eb$export$f42383286ed1223d = "loop";
var $ca9ce22b174df7eb$export$742b62a5690c060 = "fade";
function $ca9ce22b174df7eb$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $ca9ce22b174df7eb$var$getAttribute(slide, "style");
    var label = $ca9ce22b174df7eb$var$getAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $ca9ce22b174df7eb$var$child(slide, "." + $ca9ce22b174df7eb$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $ca9ce22b174df7eb$var$pad(index + 1);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ROLE, pagination ? "tabpanel" : "group");
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, label || $ca9ce22b174df7eb$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$6d5af59619d10e6a, self));
        on([
            $ca9ce22b174df7eb$export$fe5802204b967f0d,
            $ca9ce22b174df7eb$export$f0af896383d5adff,
            $ca9ce22b174df7eb$export$ff8164bff3202b9
        ], update);
        on($ca9ce22b174df7eb$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $ca9ce22b174df7eb$var$removeClass(slide, $ca9ce22b174df7eb$export$49f9eaea10ebf193);
        $ca9ce22b174df7eb$var$removeAttribute(slide, $ca9ce22b174df7eb$var$ALL_ATTRIBUTES);
        $ca9ce22b174df7eb$var$setAttribute(slide, "style", styles);
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, $ca9ce22b174df7eb$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_CONTROLS, controls);
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $ca9ce22b174df7eb$var$removeAttribute(slide, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$e423ac4972f5e196, index === curr - 1);
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $ca9ce22b174df7eb$var$hasClass(slide, $ca9ce22b174df7eb$export$72d36ecf3758cb4b)) {
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$72d36ecf3758cb4b, active);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $ca9ce22b174df7eb$export$92e3eae133acac4c : $ca9ce22b174df7eb$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $ca9ce22b174df7eb$var$MOVING,
            $ca9ce22b174df7eb$var$SCROLLING
        ])) $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_HIDDEN, hidden || "");
        $ca9ce22b174df7eb$var$setAttribute($ca9ce22b174df7eb$var$queryAll(slide, options.focusableNodes || ""), $ca9ce22b174df7eb$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $ca9ce22b174df7eb$var$hasClass(slide, $ca9ce22b174df7eb$export$53ca4621bbab9a)) {
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$53ca4621bbab9a, visible);
            emit(visible ? $ca9ce22b174df7eb$export$6a5b3445e4066a53 : $ca9ce22b174df7eb$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $ca9ce22b174df7eb$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $ca9ce22b174df7eb$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) return isActive();
        var trackRect = $ca9ce22b174df7eb$var$rect(Components.Elements.track);
        var slideRect = $ca9ce22b174df7eb$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $ca9ce22b174df7eb$var$floor(trackRect[left]) <= $ca9ce22b174df7eb$var$ceil(slideRect[left]) && $ca9ce22b174df7eb$var$floor(slideRect[right]) <= $ca9ce22b174df7eb$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $ca9ce22b174df7eb$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d))) diff = $ca9ce22b174df7eb$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $ca9ce22b174df7eb$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, destroy);
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $ca9ce22b174df7eb$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $ca9ce22b174df7eb$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $ca9ce22b174df7eb$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $ca9ce22b174df7eb$var$forEach(items, function(slide) {
            if ($ca9ce22b174df7eb$var$isString(slide)) slide = $ca9ce22b174df7eb$var$parseHtml(slide);
            if ($ca9ce22b174df7eb$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $ca9ce22b174df7eb$var$before(slide, ref) : $ca9ce22b174df7eb$var$append(list, slide);
                $ca9ce22b174df7eb$var$addClass(slide, options.classes.slide);
                observeImages(slide, $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$7e019dae5103a285));
            }
        });
        emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $ca9ce22b174df7eb$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($ca9ce22b174df7eb$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $ca9ce22b174df7eb$var$isString(matcher) ? $ca9ce22b174df7eb$var$matches(Slide2.slide, matcher) : $ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $ca9ce22b174df7eb$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $ca9ce22b174df7eb$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $ca9ce22b174df7eb$export$efff0f5979573c99($ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$7e019dae5103a285)));
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], init);
        on($ca9ce22b174df7eb$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $ca9ce22b174df7eb$export$97170d9824b89709;
        $ca9ce22b174df7eb$var$style(root, "maxWidth", $ca9ce22b174df7eb$var$unit(options.width));
        $ca9ce22b174df7eb$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $ca9ce22b174df7eb$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $ca9ce22b174df7eb$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $ca9ce22b174df7eb$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $ca9ce22b174df7eb$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($ca9ce22b174df7eb$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $ca9ce22b174df7eb$var$toggleClass(root, $ca9ce22b174df7eb$export$cd908cd1dd625e29, overflow);
                emit($ca9ce22b174df7eb$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $ca9ce22b174df7eb$var$unit(padding[prop] || ($ca9ce22b174df7eb$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $ca9ce22b174df7eb$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $ca9ce22b174df7eb$var$unit(options.height || $ca9ce22b174df7eb$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $ca9ce22b174df7eb$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $ca9ce22b174df7eb$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $ca9ce22b174df7eb$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $ca9ce22b174df7eb$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $ca9ce22b174df7eb$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $ca9ce22b174df7eb$var$rect(Slide.slide)[resolve("right")];
            var left = $ca9ce22b174df7eb$var$rect(list)[resolve("left")];
            return $ca9ce22b174df7eb$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($ca9ce22b174df7eb$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($ca9ce22b174df7eb$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $ca9ce22b174df7eb$var$MULTIPLIER = 2;
function $ca9ce22b174df7eb$var$Clones(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, remount);
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $ca9ce22b174df7eb$var$remove(clones);
        $ca9ce22b174df7eb$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$ca9ce22b174df7eb$var$push(slides, slides);
            $ca9ce22b174df7eb$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $ca9ce22b174df7eb$var$before(clone, slides[0].slide) : $ca9ce22b174df7eb$var$append(Elements.list, clone);
                $ca9ce22b174df7eb$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $ca9ce22b174df7eb$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $ca9ce22b174df7eb$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d)) clones2 = 0;
        else if ($ca9ce22b174df7eb$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $ca9ce22b174df7eb$var$ceil($ca9ce22b174df7eb$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $ca9ce22b174df7eb$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $ca9ce22b174df7eb$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$d637eba1e9e28482,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($ca9ce22b174df7eb$var$MOVING);
        emit($ca9ce22b174df7eb$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($ca9ce22b174df7eb$var$IDLE);
            emit($ca9ce22b174df7eb$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $ca9ce22b174df7eb$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($ca9ce22b174df7eb$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($ca9ce22b174df7eb$var$ceil($ca9ce22b174df7eb$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $ca9ce22b174df7eb$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $ca9ce22b174df7eb$var$rect(list)[left] - $ca9ce22b174df7eb$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22)) position = $ca9ce22b174df7eb$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $ca9ce22b174df7eb$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $ca9ce22b174df7eb$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $ca9ce22b174df7eb$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d);
    var isSlide = Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22);
    var getNext = $ca9ce22b174df7eb$var$apply(getAdjacent, false);
    var getPrev = $ca9ce22b174df7eb$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], init);
        on($ca9ce22b174df7eb$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $ca9ce22b174df7eb$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($ca9ce22b174df7eb$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $ca9ce22b174df7eb$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($ca9ce22b174df7eb$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $ca9ce22b174df7eb$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$ca9ce22b174df7eb$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($ca9ce22b174df7eb$var$between(0, dest, from, true) || $ca9ce22b174df7eb$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $ca9ce22b174df7eb$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $ca9ce22b174df7eb$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $ca9ce22b174df7eb$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $ca9ce22b174df7eb$var$min(index, endIndex) : $ca9ce22b174df7eb$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $ca9ce22b174df7eb$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$ca9ce22b174df7eb$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $ca9ce22b174df7eb$var$MOVING,
            $ca9ce22b174df7eb$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $ca9ce22b174df7eb$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $ca9ce22b174df7eb$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $ca9ce22b174df7eb$var$SIZE = 40;
function $ca9ce22b174df7eb$var$Arrows(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $ca9ce22b174df7eb$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $ca9ce22b174df7eb$var$display(wrapper, enabled ? "" : "none");
            $ca9ce22b174df7eb$var$addClass(wrapper, wrapperClasses = $ca9ce22b174df7eb$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $ca9ce22b174df7eb$var$setAttribute([
                    prev,
                    next
                ], $ca9ce22b174df7eb$var$ARIA_CONTROLS, track.id);
                emit($ca9ce22b174df7eb$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $ca9ce22b174df7eb$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $ca9ce22b174df7eb$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $ca9ce22b174df7eb$var$removeAttribute([
            prev,
            next
        ], $ca9ce22b174df7eb$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$fe5802204b967f0d,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$ff8164bff3202b9,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], update);
        bind(next, "click", $ca9ce22b174df7eb$var$apply(go, ">"));
        bind(prev, "click", $ca9ce22b174df7eb$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $ca9ce22b174df7eb$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $ca9ce22b174df7eb$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $ca9ce22b174df7eb$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $ca9ce22b174df7eb$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $ca9ce22b174df7eb$var$SIZE + " " + $ca9ce22b174df7eb$var$SIZE + "\" width=\"" + $ca9ce22b174df7eb$var$SIZE + "\" height=\"" + $ca9ce22b174df7eb$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $ca9ce22b174df7eb$var$PATH) + "\" />";
        return $ca9ce22b174df7eb$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $ca9ce22b174df7eb$var$setAttribute(prev, $ca9ce22b174df7eb$var$ARIA_LABEL, prevLabel);
            $ca9ce22b174df7eb$var$setAttribute(next, $ca9ce22b174df7eb$var$ARIA_LABEL, nextLabel);
            emit($ca9ce22b174df7eb$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $ca9ce22b174df7eb$var$INTERVAL_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$DATA_ATTRIBUTE + "-interval";
function $ca9ce22b174df7eb$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $ca9ce22b174df7eb$var$setAttribute(toggle, $ca9ce22b174df7eb$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $ca9ce22b174df7eb$export$2aa493d7c3275167,
            $ca9ce22b174df7eb$export$49801896908b5e33,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($ca9ce22b174df7eb$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($ca9ce22b174df7eb$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $ca9ce22b174df7eb$var$toggleClass(toggle, $ca9ce22b174df7eb$export$72d36ecf3758cb4b, !stopped);
            $ca9ce22b174df7eb$var$setAttribute(toggle, $ca9ce22b174df7eb$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $ca9ce22b174df7eb$var$style(bar, "width", rate * 100 + "%");
        emit($ca9ce22b174df7eb$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$ca9ce22b174df7eb$var$getAttribute(Slide.slide, $ca9ce22b174df7eb$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $ca9ce22b174df7eb$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($ca9ce22b174df7eb$export$9f64346e17f0ec8e, $ca9ce22b174df7eb$var$apply(toggle, true));
            on([
                $ca9ce22b174df7eb$export$d300dc1a2634364b,
                $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
                $ca9ce22b174df7eb$export$7f4701ac5e05e39f
            ], $ca9ce22b174df7eb$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $ca9ce22b174df7eb$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $ca9ce22b174df7eb$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $ca9ce22b174df7eb$var$apply(cover, false)
    };
}
var $ca9ce22b174df7eb$var$BOUNCE_DIFF_THRESHOLD = 10;
var $ca9ce22b174df7eb$var$BOUNCE_DURATION = 600;
var $ca9ce22b174df7eb$var$FRICTION_FACTOR = 0.6;
var $ca9ce22b174df7eb$var$BASE_VELOCITY = 1.5;
var $ca9ce22b174df7eb$var$MIN_DURATION = 800;
function $ca9ce22b174df7eb$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, clear);
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $ca9ce22b174df7eb$var$sign(destination) * size * $ca9ce22b174df7eb$var$floor($ca9ce22b174df7eb$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $ca9ce22b174df7eb$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $ca9ce22b174df7eb$var$max($ca9ce22b174df7eb$var$abs(destination - from) / $ca9ce22b174df7eb$var$BASE_VELOCITY, $ca9ce22b174df7eb$var$MIN_DURATION);
        callback = onScrolled;
        interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(duration, onEnd, $ca9ce22b174df7eb$var$apply(update, from, destination, noConstrain), 1);
        set($ca9ce22b174df7eb$var$SCROLLING);
        emit($ca9ce22b174df7eb$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($ca9ce22b174df7eb$var$IDLE);
        callback && callback();
        emit($ca9ce22b174df7eb$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $ca9ce22b174df7eb$var$FRICTION_FACTOR;
            if ($ca9ce22b174df7eb$var$abs(diff) < $ca9ce22b174df7eb$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $ca9ce22b174df7eb$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $ca9ce22b174df7eb$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, $ca9ce22b174df7eb$var$noop, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, $ca9ce22b174df7eb$var$noop, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS, onPointerDown, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $ca9ce22b174df7eb$var$prevent);
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $ca9ce22b174df7eb$var$MOVING,
                        $ca9ce22b174df7eb$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, onPointerMove, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, onPointerUp, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $ca9ce22b174df7eb$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($ca9ce22b174df7eb$var$DRAGGING)) {
            state.set($ca9ce22b174df7eb$var$DRAGGING);
            emit($ca9ce22b174df7eb$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $ca9ce22b174df7eb$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($ca9ce22b174df7eb$export$8e9f636d2c722196);
                $ca9ce22b174df7eb$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $ca9ce22b174df7eb$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($ca9ce22b174df7eb$var$DRAGGING)) {
            state.set($ca9ce22b174df7eb$var$IDLE);
            emit($ca9ce22b174df7eb$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $ca9ce22b174df7eb$var$prevent(e);
        }
        unbind(target, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $ca9ce22b174df7eb$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) Controller.go(orient($ca9ce22b174df7eb$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $ca9ce22b174df7eb$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $ca9ce22b174df7eb$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $ca9ce22b174df7eb$var$abs(diffCoord(e)) > $ca9ce22b174df7eb$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $ca9ce22b174df7eb$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $ca9ce22b174df7eb$var$sign(velocity) * $ca9ce22b174df7eb$var$min($ca9ce22b174df7eb$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $ca9ce22b174df7eb$var$timeOf(e) - $ca9ce22b174df7eb$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) ? $ca9ce22b174df7eb$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$ca9ce22b174df7eb$var$matches(target2, "." + $ca9ce22b174df7eb$export$52f2cca6a5eee805 + ", ." + $ca9ce22b174df7eb$export$516e7d18e13a2dca) && (!noDrag || !$ca9ce22b174df7eb$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $ca9ce22b174df7eb$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $ca9ce22b174df7eb$var$ARROW_RIGHT,
    Left: $ca9ce22b174df7eb$var$ARROW_LEFT,
    Up: $ca9ce22b174df7eb$var$ARROW_UP,
    Down: $ca9ce22b174df7eb$var$ARROW_DOWN
};
function $ca9ce22b174df7eb$var$normalizeKey(key) {
    key = $ca9ce22b174df7eb$var$isString(key) ? key : key.key;
    return $ca9ce22b174df7eb$var$NORMALIZATION_MAP[key] || key;
}
var $ca9ce22b174df7eb$var$KEYBOARD_EVENT = "keydown";
function $ca9ce22b174df7eb$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, destroy);
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, init);
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $ca9ce22b174df7eb$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $ca9ce22b174df7eb$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $ca9ce22b174df7eb$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $ca9ce22b174df7eb$var$normalizeKey(e);
            if (key === resolve($ca9ce22b174df7eb$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($ca9ce22b174df7eb$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$DATA_ATTRIBUTE + "-lazy";
var $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $ca9ce22b174df7eb$var$IMAGE_SELECTOR = "[" + $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE + "], [" + $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE + "]";
function $ca9ce22b174df7eb$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $ca9ce22b174df7eb$export$fe5802204b967f0d,
        $ca9ce22b174df7eb$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $ca9ce22b174df7eb$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $ca9ce22b174df7eb$var$queryAll(Slide.slide, $ca9ce22b174df7eb$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE);
                var srcset = $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $ca9ce22b174df7eb$var$child(parent, "." + className) || $ca9ce22b174df7eb$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $ca9ce22b174df7eb$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $ca9ce22b174df7eb$var$addClass(data[1].slide, $ca9ce22b174df7eb$export$d22ec4ccb7996ba2);
        bind(img, "load error", $ca9ce22b174df7eb$var$apply(onLoad, data));
        $ca9ce22b174df7eb$var$setAttribute(img, "src", $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE));
        $ca9ce22b174df7eb$var$setAttribute(img, "srcset", $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE));
        $ca9ce22b174df7eb$var$removeAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE);
        $ca9ce22b174df7eb$var$removeAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $ca9ce22b174df7eb$var$removeClass(Slide.slide, $ca9ce22b174df7eb$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $ca9ce22b174df7eb$var$remove(data[2]);
            $ca9ce22b174df7eb$var$display(img, "");
            emit($ca9ce22b174df7eb$export$9f64346e17f0ec8e, img, Slide);
            emit($ca9ce22b174df7eb$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$empty, entries),
        check: check
    };
}
function $ca9ce22b174df7eb$var$Pagination(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $ca9ce22b174df7eb$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $ca9ce22b174df7eb$export$2aa493d7c3275167,
                $ca9ce22b174df7eb$export$49801896908b5e33,
                $ca9ce22b174df7eb$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($ca9ce22b174df7eb$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $ca9ce22b174df7eb$var$remove(placeholder ? $ca9ce22b174df7eb$var$slice(list.children) : list);
            $ca9ce22b174df7eb$var$removeClass(list, paginationClasses);
            $ca9ce22b174df7eb$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $ca9ce22b174df7eb$var$ceil(length / perPage);
        list = placeholder || $ca9ce22b174df7eb$var$create("ul", classes.pagination, Elements.track.parentElement);
        $ca9ce22b174df7eb$var$addClass(list, paginationClasses = $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ROLE, "tablist");
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ARIA_LABEL, i18n.select);
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ARIA_ORIENTATION, getDirection() === $ca9ce22b174df7eb$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $ca9ce22b174df7eb$var$create("li", null, list);
            var button = $ca9ce22b174df7eb$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $ca9ce22b174df7eb$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $ca9ce22b174df7eb$var$apply(onKeydown, i));
            $ca9ce22b174df7eb$var$setAttribute(li, $ca9ce22b174df7eb$var$ROLE, "presentation");
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ROLE, "tab");
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ARIA_CONTROLS, controls.join(" "));
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ARIA_LABEL, $ca9ce22b174df7eb$var$format(text, i + 1));
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $ca9ce22b174df7eb$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($ca9ce22b174df7eb$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($ca9ce22b174df7eb$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $ca9ce22b174df7eb$var$focus(item.button);
            go(">" + nextPage);
            $ca9ce22b174df7eb$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $ca9ce22b174df7eb$var$removeClass(button, $ca9ce22b174df7eb$export$72d36ecf3758cb4b);
            $ca9ce22b174df7eb$var$removeAttribute(button, $ca9ce22b174df7eb$var$ARIA_SELECTED);
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $ca9ce22b174df7eb$var$addClass(_button, $ca9ce22b174df7eb$export$72d36ecf3758cb4b);
            $ca9ce22b174df7eb$var$setAttribute(_button, $ca9ce22b174df7eb$var$ARIA_SELECTED, true);
            $ca9ce22b174df7eb$var$setAttribute(_button, $ca9ce22b174df7eb$var$TAB_INDEX, "");
        }
        emit($ca9ce22b174df7eb$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $ca9ce22b174df7eb$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $ca9ce22b174df7eb$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $ca9ce22b174df7eb$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(splide);
        event.on($ca9ce22b174df7eb$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($ca9ce22b174df7eb$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($ca9ce22b174df7eb$export$5adb665701eda1ce, onClick);
        on($ca9ce22b174df7eb$export$6d5af59619d10e6a, onKeydown);
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($ca9ce22b174df7eb$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $ca9ce22b174df7eb$var$setAttribute(Components2.Elements.list, $ca9ce22b174df7eb$var$ARIA_ORIENTATION, options.direction === $ca9ce22b174df7eb$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$TRIGGER_KEYS, $ca9ce22b174df7eb$var$normalizeKey(e))) {
            onClick(Slide);
            $ca9ce22b174df7eb$var$prevent(e);
        }
    }
    return {
        setup: $ca9ce22b174df7eb$var$apply(Components2.Media.set, {
            slideFocus: $ca9ce22b174df7eb$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $ca9ce22b174df7eb$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $ca9ce22b174df7eb$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($ca9ce22b174df7eb$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $ca9ce22b174df7eb$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($ca9ce22b174df7eb$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $ca9ce22b174df7eb$var$SR_REMOVAL_DELAY = 90;
function $ca9ce22b174df7eb$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $ca9ce22b174df7eb$var$create("span", $ca9ce22b174df7eb$export$bb78d7c200da8960);
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0($ca9ce22b174df7eb$var$SR_REMOVAL_DELAY, $ca9ce22b174df7eb$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($ca9ce22b174df7eb$export$23663268a31b79e2, $ca9ce22b174df7eb$var$apply(disable, true));
            on($ca9ce22b174df7eb$export$16a1e4f3d0368265, $ca9ce22b174df7eb$var$apply(disable, false));
            on([
                $ca9ce22b174df7eb$export$fe5802204b967f0d,
                $ca9ce22b174df7eb$export$ff8164bff3202b9
            ], $ca9ce22b174df7eb$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_BUSY, active);
        if (active) {
            $ca9ce22b174df7eb$var$append(track, sr);
            interval.start();
        } else {
            $ca9ce22b174df7eb$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $ca9ce22b174df7eb$var$removeAttribute(track, [
            $ca9ce22b174df7eb$var$ARIA_LIVE,
            $ca9ce22b174df7eb$var$ARIA_ATOMIC,
            $ca9ce22b174df7eb$var$ARIA_BUSY
        ]);
        $ca9ce22b174df7eb$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $ca9ce22b174df7eb$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $ca9ce22b174df7eb$var$Media,
    Direction: $ca9ce22b174df7eb$var$Direction,
    Elements: $ca9ce22b174df7eb$var$Elements,
    Slides: $ca9ce22b174df7eb$var$Slides,
    Layout: $ca9ce22b174df7eb$var$Layout,
    Clones: $ca9ce22b174df7eb$var$Clones,
    Move: $ca9ce22b174df7eb$var$Move,
    Controller: $ca9ce22b174df7eb$var$Controller,
    Arrows: $ca9ce22b174df7eb$var$Arrows,
    Autoplay: $ca9ce22b174df7eb$var$Autoplay,
    Cover: $ca9ce22b174df7eb$var$Cover,
    Scroll: $ca9ce22b174df7eb$var$Scroll,
    Drag: $ca9ce22b174df7eb$var$Drag,
    Keyboard: $ca9ce22b174df7eb$var$Keyboard,
    LazyLoad: $ca9ce22b174df7eb$var$LazyLoad,
    Pagination: $ca9ce22b174df7eb$var$Pagination,
    Sync: $ca9ce22b174df7eb$var$Sync,
    Wheel: $ca9ce22b174df7eb$var$Wheel,
    Live: $ca9ce22b174df7eb$var$Live
});
var $ca9ce22b174df7eb$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $ca9ce22b174df7eb$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $ca9ce22b174df7eb$export$ba41d43e4a419565,
    i18n: $ca9ce22b174df7eb$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $ca9ce22b174df7eb$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2).on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $ca9ce22b174df7eb$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $ca9ce22b174df7eb$var$noop
    };
}
function $ca9ce22b174df7eb$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$style, list, "transition");
    var endCallback;
    function mount() {
        $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($ca9ce22b174df7eb$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $ca9ce22b174df7eb$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $ca9ce22b174df7eb$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $ca9ce22b174df7eb$export$7254cc27399e90bd($ca9ce22b174df7eb$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $ca9ce22b174df7eb$var$isString(target) ? $ca9ce22b174df7eb$var$query(document, target) : target;
        $ca9ce22b174df7eb$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $ca9ce22b174df7eb$var$merge({
            label: $ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABEL) || "",
            labelledby: $ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABELLEDBY) || ""
        }, $ca9ce22b174df7eb$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $ca9ce22b174df7eb$var$merge(options, JSON.parse($ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $ca9ce22b174df7eb$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($ca9ce22b174df7eb$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $ca9ce22b174df7eb$var$assert(state.is([
            $ca9ce22b174df7eb$var$CREATED,
            $ca9ce22b174df7eb$var$DESTROYED
        ]), "Already mounted!");
        state.set($ca9ce22b174df7eb$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($ca9ce22b174df7eb$export$742b62a5690c060) ? $ca9ce22b174df7eb$var$Fade : $ca9ce22b174df7eb$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $ca9ce22b174df7eb$var$assign({}, $ca9ce22b174df7eb$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $ca9ce22b174df7eb$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $ca9ce22b174df7eb$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($ca9ce22b174df7eb$export$d300dc1a2634364b);
        $ca9ce22b174df7eb$var$addClass(this.root, $ca9ce22b174df7eb$export$7761661e2d5b9388);
        state.set($ca9ce22b174df7eb$var$IDLE);
        this.emit($ca9ce22b174df7eb$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($ca9ce22b174df7eb$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($ca9ce22b174df7eb$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($ca9ce22b174df7eb$var$CREATED)) $ca9ce22b174df7eb$export$f188226459c8a3ff(this).on($ca9ce22b174df7eb$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $ca9ce22b174df7eb$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($ca9ce22b174df7eb$export$88c4cf7419e470cd);
            event.destroy();
            completely && $ca9ce22b174df7eb$var$empty(this.splides);
            state.set($ca9ce22b174df7eb$var$DESTROYED);
        }
        return this;
    };
    $ca9ce22b174df7eb$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $ca9ce22b174df7eb$export$24494c7438c070bf = $ca9ce22b174df7eb$var$_Splide;
$ca9ce22b174df7eb$export$24494c7438c070bf.defaults = {};
$ca9ce22b174df7eb$export$24494c7438c070bf.STATES = $ca9ce22b174df7eb$var$STATES;
var $ca9ce22b174df7eb$var$CLASS_RENDERED = "is-rendered";
var $ca9ce22b174df7eb$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $ca9ce22b174df7eb$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $ca9ce22b174df7eb$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $ca9ce22b174df7eb$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $ca9ce22b174df7eb$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$export$f484e977a69c6ba6, defaults || {});
        $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$var$merge(this.options, $ca9ce22b174df7eb$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $ca9ce22b174df7eb$var$assign({}, $ca9ce22b174df7eb$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $ca9ce22b174df7eb$var$uniqueId("splide");
        this.Style = new $ca9ce22b174df7eb$var$Style(this.id, this.options);
        this.Direction = $ca9ce22b174df7eb$var$Direction(null, null, this.options);
        $ca9ce22b174df7eb$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $ca9ce22b174df7eb$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $ca9ce22b174df7eb$var$queryAll(root, "." + $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947);
        on($ca9ce22b174df7eb$export$d300dc1a2634364b, function() {
            $ca9ce22b174df7eb$var$remove($ca9ce22b174df7eb$var$child(root, "style"));
        });
        $ca9ce22b174df7eb$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $ca9ce22b174df7eb$var$push(this.slides, this.contents.map(function(content, index) {
            content = $ca9ce22b174df7eb$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $ca9ce22b174df7eb$export$72d36ecf3758cb4b : "");
            $ca9ce22b174df7eb$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $ca9ce22b174df7eb$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $ca9ce22b174df7eb$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $ca9ce22b174df7eb$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $ca9ce22b174df7eb$var$unit(padding[prop] || ($ca9ce22b174df7eb$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $ca9ce22b174df7eb$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $ca9ce22b174df7eb$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $ca9ce22b174df7eb$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $ca9ce22b174df7eb$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $ca9ce22b174df7eb$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($ca9ce22b174df7eb$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $ca9ce22b174df7eb$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $ca9ce22b174df7eb$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $ca9ce22b174df7eb$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $ca9ce22b174df7eb$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $ca9ce22b174df7eb$export$93b21159ad85c843,
            $ca9ce22b174df7eb$export$93b21159ad85c843 + "--" + options.type,
            $ca9ce22b174df7eb$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $ca9ce22b174df7eb$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $ca9ce22b174df7eb$export$93b21159ad85c843 + "--nav",
            $ca9ce22b174df7eb$export$72d36ecf3758cb4b,
            !this.config.hidden && $ca9ce22b174df7eb$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $ca9ce22b174df7eb$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $ca9ce22b174df7eb$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $ca9ce22b174df7eb$var$forOwn(styles, function(value, key) {
            style += " " + $ca9ce22b174df7eb$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$ca9ce22b174df7eb$var$push(slides, slides);
        $ca9ce22b174df7eb$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $ca9ce22b174df7eb$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $ca9ce22b174df7eb$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $ca9ce22b174df7eb$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $ca9ce22b174df7eb$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $ca9ce22b174df7eb$var$SIZE + " " + $ca9ce22b174df7eb$var$SIZE + "\" width=\"" + $ca9ce22b174df7eb$var$SIZE + "\" height=\"" + $ca9ce22b174df7eb$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $ca9ce22b174df7eb$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


var $35330021ee0eb054$exports = {};
/* offside-js 1.4.0 26-03-2018
* Minimal JavaScript kit without library dependencies to push things off-canvas using just class manipulation
* https://github.com/toomuchdesign/offside.git
*
* by Andrea Carraro
* Available under the MIT license
*/ (function(window1, document1, undefined) {
    'use strict';
    // Self-invoking function returning the object which contains
    // the "getInstance" method used for initializing
    // the Offside sigleton factory
    var offside = function() {
        // Global Offside singleton-factory constructor
        function initOffsideFactory(options) {
            // Utility functions
            // Shared among factory and Offside instances, too
            // Close all open Offsides.
            // If an Offside instance id is provided, it just closes the matching instance instead
            var closeAll = function(offsideId) {
                // Look for an open Offside id
                if (openOffsidesId.length > 0) {
                    // Close matching Offside instance if an ID is provided
                    if (!isNaN(offsideId)) instantiatedOffsides[offsideId].close();
                    else // Close all Offside instances
                    openOffsidesId.forEach(function(offsideId) {
                        instantiatedOffsides[offsideId].close();
                    });
                }
            }, // Append a class to body in order to turn on elements CSS 3D transitions
            // only when happens the first interation with an Offside instance.
            // Otherwise we would see Offside instances being smoothly pushed
            // out of the screen during DOM initialization.
            turnOnCssTransitions = function() {
                addClass(body, transitionsClass);
            }, addClass = function(el, c) {
                if (el.classList) el.classList.add(c);
                else el.className = (el.className + ' ' + c).trim();
            }, removeClass = function(el, c) {
                if (el.classList) el.classList.remove(c);
                else el.className = el.className.replace(new RegExp('(^|\\b)' + c.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }, addEvent = function(el, eventName, eventHandler) {
                el.addEventListener(eventName, eventHandler);
            }, removeEvent = function(el, eventName, eventHandler) {
                el.removeEventListener(eventName, eventHandler);
            }, // Return a collection (array) of DOM elements from:
            // - A DOM element
            // - An array of DOM elements
            // - A string selector
            getDomElements = function(els) {
                // "els" is a DOM element
                // http://stackoverflow.com/a/120275/2902821
                if (els instanceof HTMLElement) return [
                    els
                ];
                else if (Array.isArray(els)) return els;
                else if (typeof els === 'string') // Convert Nodelist into an array
                // http://www.jstips.co/en/converting-a-node-list-to-an-array/
                return Array.apply(null, document1.querySelectorAll(els));
                return false;
            }, // Check if a value exists in an array. Returns:
            // - array index if value exists
            // - "false" if value is not found
            // See: http://stackoverflow.com/a/5767357
            isInArray = function(arr, value) {
                var index = arr.indexOf(value);
                return index > -1 ? index : false;
            };
            // Offside.js factory initialization
            var i, factorySettings; // Offside factory private settings
            // Default factory settings
            factorySettings = {
                slidingElementsSelector: '.offside-sliding-element',
                disableCss3dTransforms: false,
                debug: false
            };
            // User defined factory settings
            for(i in options)if (factorySettings.hasOwnProperty(i)) factorySettings[i] = options[i];
            // Private factory properties
            var globalClass = 'offside-js', initClass = globalClass + '--init', slidingElementsClass = 'offside-sliding-element', transitionsClass = globalClass + '--interact', instantiatedOffsides = [], firstInteraction = true, has3d = factorySettings.disableCss3dTransforms ? false : _has3d(), openOffsidesId = [], body = document1.body, slidingElements = getDomElements(factorySettings.slidingElementsSelector), debug = factorySettings.debug;
            // Offside singleton-factory Dom initialization
            // It's called just once on Offside singleton-factory init.
            function _factoryDomInit() {
                // Add class to sliding elements
                slidingElements.forEach(function(item) {
                    addClass(item, slidingElementsClass);
                });
                // DOM Fallbacks when CSS transform 3d not available
                if (!has3d) // No CSS 3d Transform fallback
                addClass(document1.documentElement, 'no-csstransforms3d'); //Adds Modernizr-like class to HTML element when CSS 3D Transforms not available
                // Add init class to body
                addClass(body, initClass);
            }
            // Private Offside factory methods
            // Testing for CSS 3D Transform Support
            // https://gist.github.com/lorenzopolidori/3794226
            function _has3d() {
                if (!window1.getComputedStyle) return false;
                var el = document1.createElement('p'), has3d, transforms = {
                    'webkitTransform': '-webkit-transform',
                    'OTransform': '-o-transform',
                    'msTransform': '-ms-transform',
                    'MozTransform': '-moz-transform',
                    'transform': 'transform'
                };
                // Add it to the body to get the computed style
                document1.body.insertBefore(el, null);
                for(var t in transforms)if (el.style[t] !== undefined) {
                    el.style[t] = 'translate3d(1px,1px,1px)';
                    has3d = window1.getComputedStyle(el).getPropertyValue(transforms[t]);
                }
                document1.body.removeChild(el);
                return has3d !== undefined && has3d.length > 0 && has3d !== 'none';
            }
            // Offside constructor wrapper
            // It supplies a wrapper around OffsideInstance constructor
            // to prevent instance initialization when casted on a non-existing DOM element
            // See: http://stackoverflow.com/a/8618792
            function createOffsideInstance(el, options, offsideId) {
                // Check if provided element exists before using it to instantiate an Offside instance
                var domEl = el !== undefined ? getDomElements(el) : getDomElements('.offside');
                // If provided el exists initialize an Offside instance, else return null
                return domEl !== false ? new OffsideInstance(domEl[0], options, offsideId) : null;
            }
            // Offside constructor
            // Set up and initialize a new Offside instance
            // Called by Offside factory "getOffsideInstance()" method
            function OffsideInstance(domEl, options, offsideId) {
                var i, offsideSettings;
                // Default Offside instance settings
                offsideSettings = {
                    buttonsSelector: '',
                    slidingSide: 'left',
                    init: function() {},
                    beforeOpen: function() {},
                    afterOpen: function() {},
                    beforeClose: function() {},
                    afterClose: function() {},
                    beforeDestroy: function() {},
                    afterDestroy: function() {}
                };
                // User defined Offside instance settings
                for(i in options)if (offsideSettings.hasOwnProperty(i)) offsideSettings[i] = options[i];
                // Offside instance private properties
                var offside = domEl, offsideButtons = getDomElements(offsideSettings.buttonsSelector), slidingSide = offsideSettings.slidingSide, offsideClass = 'offside', offsideSideClass = offsideClass + '--' + slidingSide, offsideOpenClass = 'is-open', offsideBodyOpenClass = globalClass + '--' + 'is-open', offsideBodyOpenSideClass = globalClass + '--is-' + slidingSide, id = offsideId || 0; // Offside instance id
                // Offside instance private methods
                var _toggleOffside = function() {
                    // Premise: Just 1 Offside instance at time can be open.
                    // Check currently toggling Offside status
                    isInArray(openOffsidesId, id) === false ? _openOffside() : _closeOffside();
                }, _openOffside = function() {
                    // beforeOpen callback
                    offsideSettings.beforeOpen();
                    // Turn on CSS transitions on first interaction with an Offside instance
                    if (firstInteraction) {
                        firstInteraction = false;
                        turnOnCssTransitions();
                    }
                    // If another Offside instance is already open,
                    // close it before going on
                    closeAll();
                    // Set global body active class for current Offside instance
                    addClass(body, offsideBodyOpenClass);
                    addClass(body, offsideBodyOpenSideClass);
                    // Add Offside instance open class
                    addClass(offside, offsideOpenClass);
                    // Update open Offside instances tracker
                    openOffsidesId.push(id);
                    // afterOpen callback
                    offsideSettings.afterOpen();
                }, _closeOffside = function() {
                    // Proceed with closing stuff only if
                    // current Offside instance is listed among openOffsidesId array
                    var index = isInArray(openOffsidesId, id);
                    if (index !== false) {
                        // beforeClose callback
                        offsideSettings.beforeClose();
                        // Remove global body active class for current Offside instance
                        removeClass(body, offsideBodyOpenClass);
                        removeClass(body, offsideBodyOpenSideClass);
                        // Remove Offside instance open class
                        removeClass(offside, offsideOpenClass);
                        // Update open Offside instances tracker
                        openOffsidesId.splice(index, 1);
                        // afterClose callback
                        offsideSettings.afterClose();
                    }
                }, _closeAll = function() {
                    closeAll();
                }, // Offside buttons click handler
                _onButtonClick = function(e) {
                    e.preventDefault();
                    _toggleOffside();
                }, /*
                // Get Offside instance unique ID
                _getId = function() {
                    return id;
                }
                */ // Set up and initialize a new Offside instance
                _initOffside = function() {
                    if (debug) _checkElements();
                    // Append classes to Offside instance (.offside and .offside{slidingSide})
                    addClass(offside, offsideClass);
                    addClass(offside, offsideSideClass);
                    // Toggle Offside on click event
                    offsideButtons.forEach(function(item) {
                        addEvent(item, 'click', _onButtonClick);
                    });
                    // Init callback
                    offsideSettings.init();
                }, _destroyOffside = function() {
                    // beforeDestroy callback
                    offsideSettings.beforeDestroy();
                    // Close Offside intance before destroy
                    _closeOffside();
                    // Remove click event from Offside buttons
                    offsideButtons.forEach(function(item) {
                        removeEvent(item, 'click', _onButtonClick);
                    });
                    // Remove classes appended on init phase
                    removeClass(offside, offsideClass);
                    removeClass(offside, offsideSideClass);
                    // Destroy Offside instance
                    delete instantiatedOffsides[id];
                    // afterDestroy callback
                    offsideSettings.afterDestroy();
                }, // Fire console errors if DOM elements are missing
                _checkElements = function() {
                    if (!offside) console.error('Offside alert: "offside" selector could not match any element');
                    if (!offsideButtons.length) console.error('Offside alert: "buttonsSelector" selector could not match any element');
                };
                // Offside instances public methods
                this.toggle = function() {
                    _toggleOffside();
                };
                this.open = function() {
                    _openOffside();
                };
                this.close = function() {
                    _closeOffside();
                };
                this.closeAll = function() {
                    _closeAll();
                };
                this.destroy = function() {
                    _destroyOffside();
                };
                // Ok, init Offside instance
                _initOffside();
            } // OffsideInstance constructor end
            // DOM initialization
            _factoryDomInit();
            // This is the actual returned Offside factory
            return {
                //Offside factory public methods
                closeOpenOffside: function() {
                    closeAll();
                },
                // This is the method responsible for creating a new Offside instance
                // and register it into "instantiatedOffsides" array
                getOffsideInstance: function(el, options) {
                    // Get length of instantiated Offsides array
                    var offsideId = instantiatedOffsides.length || 0, // Instantiate new Offside instance
                    offsideInstance = createOffsideInstance(el, options, offsideId);
                    // If Offside instance is sccessfully created
                    if (offsideInstance !== null) // Push new instance into "instantiatedOffsides" array and return it
                    /*jshint -W093 */ return instantiatedOffsides[offsideId] = offsideInstance;
                }
            };
        } // initOffsideFactory() end
        var singleton = {
            // Get the Singleton instance if one exists
            // or create one if it doesn't
            getInstance: function(el, options) {
                /*
                * When Offside is called for the first time,
                * inject a singleton-factory object
                * as a static method in "offside.factory".
                *
                * Offside factory serves the following purposes:
                * - DOM initialization
                * - Centralized Offside instances management and initialization
                */ if (!singleton.getInstance.factory) singleton.getInstance.factory = initOffsideFactory(options);
                return singleton.getInstance.factory.getOffsideInstance(el, options);
            }
        };
        return singleton;
    }();
    // Store in window a reference to the Offside singleton factory
    if ($35330021ee0eb054$exports) $35330021ee0eb054$exports = offside.getInstance;
    else window1.offside = offside.getInstance;
})(window, document);



var $a6897314d3ddc1a0$var$DropdownState = /*#__PURE__*/ function(DropdownState) {
    DropdownState[DropdownState["ON"] = 0] = "ON";
    DropdownState[DropdownState["OFF"] = 1] = "OFF";
    return DropdownState;
}($a6897314d3ddc1a0$var$DropdownState || {});
let $a6897314d3ddc1a0$var$CURRENT_STATE = 1;
let $a6897314d3ddc1a0$var$CURRENT_ACTIVE = null;
// initiated on `initNavigationDropdown`
let $a6897314d3ddc1a0$var$MODAL;
function $a6897314d3ddc1a0$export$84570464b5512114() {
    // this should be called after window load;
    $a6897314d3ddc1a0$var$MODAL = (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))("#modal-bg");
    const dropSelector = (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))("li[data-dropdown]");
    dropSelector.each(function(idx, li_dropdown) {
        let menuElement = (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))(li_dropdown);
        menuElement.on("click", (ev)=>{
            ev.stopPropagation();
            // close dropdown if we click at the selector one more time
            if (menuElement.data("dropdown") == $a6897314d3ddc1a0$var$CURRENT_ACTIVE) {
                $a6897314d3ddc1a0$var$closeDropdown(dropSelector, menuElement);
                return;
            }
            $a6897314d3ddc1a0$var$openDropdown(dropSelector, menuElement);
        });
        $a6897314d3ddc1a0$var$MODAL.on("click", (ev)=>{
            ev.stopPropagation();
            $a6897314d3ddc1a0$var$closeDropdown(dropSelector, menuElement);
        });
    });
}
function $a6897314d3ddc1a0$var$handleCarets(coll, clickedElement) {
    coll.children().removeClass("fa-caret-up");
    if (clickedElement ?? false) {
        clickedElement.children().addClass("fa-caret-up");
        return;
    }
}
function $a6897314d3ddc1a0$var$openDropdown(menuElements, clickedElement) {
    $a6897314d3ddc1a0$var$CURRENT_STATE = 0;
    $a6897314d3ddc1a0$var$CURRENT_ACTIVE = clickedElement.data("dropdown");
    if ($a6897314d3ddc1a0$var$MODAL.hasClass("hidden")) $a6897314d3ddc1a0$var$MODAL.toggleClass("hidden");
    $a6897314d3ddc1a0$var$handleCarets(menuElements, clickedElement);
    const dropdownChildren = (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))("#modal-bg").children();
    dropdownChildren.addClass("hidden");
    const name = clickedElement.data("dropdown");
    (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))(`#${name}`).removeClass("hidden");
}
function $a6897314d3ddc1a0$var$closeDropdown(menuElements, clickedElement) {
    $a6897314d3ddc1a0$var$CURRENT_STATE = 1;
    $a6897314d3ddc1a0$var$CURRENT_ACTIVE = null;
    $a6897314d3ddc1a0$var$MODAL.addClass("hidden");
    $a6897314d3ddc1a0$var$handleCarets(menuElements, null);
}


var $3036a9dd6515626d$exports = {};
!function(e, t) {
    var n, o;
    $3036a9dd6515626d$exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function n(o) {
            if (t[o]) return t[o].exports;
            var i = t[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(o, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return o;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, i = "fslightbox-", s = "".concat(i, "styles"), r = "".concat(i, "cursor-grabbing"), a = "".concat(i, "full-dimension"), c = "".concat(i, "flex-centered"), l = "".concat(i, "open"), u = "".concat(i, "transform-transition"), d = "".concat(i, "absoluted"), f = "".concat(i, "slide-btn"), p = "".concat(f, "-container"), h = "".concat(i, "fade-in"), g = "".concat(i, "fade-out"), m = h + "-strong", b = g + "-strong", v = "".concat(i, "opacity-"), x = "".concat(v, "1"), y = "".concat(i, "source");
            function w(e) {
                return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function S(e) {
                var t = e.stageIndexes, n = e.core.stageManager, o = e.props.sources.length - 1;
                n.getPreviousSlideIndex = function() {
                    return 0 === t.current ? o : t.current - 1;
                }, n.getNextSlideIndex = function() {
                    return t.current === o ? 0 : t.current + 1;
                }, n.updateStageIndexes = 0 === o ? function() {} : 1 === o ? function() {
                    0 === t.current ? (t.next = 1, delete t.previous) : (t.previous = 0, delete t.next);
                } : function() {
                    t.previous = n.getPreviousSlideIndex(), t.next = n.getNextSlideIndex();
                }, n.i = o <= 2 ? function() {
                    return !0;
                } : function(e) {
                    var n = t.current;
                    if (0 === n && e === o || n === o && 0 === e) return !0;
                    var i = n - e;
                    return -1 === i || 0 === i || 1 === i;
                };
            }
            "object" === ("undefined" == typeof document ? "undefined" : w(document)) && ((o = document.createElement("style")).className = s, o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg{width:20px;height:20px}.fslightbox-svgp{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightboxsn{z-index:0;display:flex;align-items:center;margin:14px 0 0 11px;font-size:15px;color:#d7d7d7}.fslightboxsn span{display:inline;vertical-align:middle}.fslightboxsl{display:inline-block!important;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:white}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex}.fslightbox-toolbar-button{width:45px;height:100%}.fslightbox-fsx{width:24px;height:24px}.fslightboxb{border:0;background:rgba(35,35,35,.65);cursor:pointer}.fslightboxb:focus{outline:0}.fslightboxb:focus .fslightbox-svgp{fill:#fff}.fslightboxb:hover .fslightbox-svgp{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}.fslightbox-slide-btn-container-next{padding-right:6px!important;padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}.fslightbox-slide-btn-container-next{padding-left:30px}.fslightbox-slide-btn{padding:10px}}.fslightbox-slide-btn-container:hover .fslightbox-svgp{fill:#fff}.fslightbox-slide-btn{padding:9px}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightboxv{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}@media (min-width:1200px){.fslightboxsn{margin:15px 0 0 12px;font-size:16px;display:block}.fslightboxsl{margin:0 6px 1px 6px;height:14px}.fslightbox-slide-btn{padding:11px}.fslightbox-svg{width:22px;height:22px}.fslightbox-fsx{width:26px;height:26px}.fslightbox-fso{width:22px;height:22px}.fslightboxl div{width:60px;height:60px;border-width:6px;border-color:#999 transparent transparent transparent;border-radius:50%}}@media (min-width:1600px){.fslightbox-nav{height:50px}.fslightboxsn{display:flex;margin:19px 0 0 16px;font-size:20px}.fslightboxsl{margin:0 7px 1px 7px;height:16px;width:2px;background:#d7d7d7}.fslightbox-toolbar-button{width:50px}.fslightbox-slide-btn{padding:12px}.fslightbox-svg{width:24px;height:24px}.fslightbox-fsx{width:28px;height:28px}.fslightbox-fso{width:24px;height:24px}}")), document.head.appendChild(o));
            function L(e) {
                var t, n = e.props, o = 0, i = {};
                this.getSourceTypeFromLocalStorageByUrl = function(e) {
                    return t[e] ? t[e] : s(e);
                }, this.handleReceivedSourceTypeForUrl = function(e, n) {
                    if (!1 === i[n] && (o--, "invalid" !== e ? i[n] = e : delete i[n], 0 === o)) {
                        !function(e, t) {
                            for(var n in t)e[n] = t[n];
                        }(t, i);
                        try {
                            localStorage.setItem("fslightbox-types", JSON.stringify(t));
                        } catch (e) {}
                    }
                };
                var s = function(e) {
                    o++, i[e] = !1;
                };
                if (n.disableLocalStorage) this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {};
                else {
                    try {
                        t = JSON.parse(localStorage.getItem("fslightbox-types"));
                    } catch (e) {}
                    t || (t = {}, this.getSourceTypeFromLocalStorageByUrl = s);
                }
            }
            function C(e, t, n, o) {
                e.data;
                var i = e.elements.sources, s = n / o, r = 0;
                this.adjustSize = function() {
                    if ((r = e.mw / s) < e.mh) return n < e.mw && (r = o), a();
                    r = o > e.mh ? e.mh : o, a();
                };
                var a = function() {
                    i[t].style.width = r * s + "px", i[t].style.height = r + "px";
                };
            }
            function A(e, t) {
                var n = this, o = e.collections.sourceSizers, i = e.elements, s = i.sourceAnimationWrappers, r = i.sources, a = e.isl, c = e.props.onSourceLoad, l = e.resolve;
                function u(e, n) {
                    o[t] = l(C, [
                        t,
                        e,
                        n
                    ]), o[t].adjustSize();
                }
                this.b = function(e, o) {
                    r[t].classList.add(x), n.a(), u(e, o), n.b = u;
                }, this.a = function() {
                    a[t] = !0, s[t].classList.add(m), s[t].removeChild(s[t].firstChild), c && c(e, r[t], t);
                };
            }
            function E(e, t) {
                var n, o = this, i = e.elements.sources, s = e.props, r = (0, e.resolve)(A, [
                    t
                ]);
                this.handleImageLoad = function(e) {
                    var t = e.target, n = t.naturalWidth, o = t.naturalHeight;
                    r.b(n, o);
                }, this.handleVideoLoad = function(e) {
                    var t = e.target, o = t.videoWidth, i = t.videoHeight;
                    n = !0, r.b(o, i);
                }, this.handleNotMetaDatedVideoLoad = function() {
                    n || o.handleYoutubeLoad();
                }, this.handleYoutubeLoad = function(e, t) {
                    e || (e = 1920, t = 1080), s.maxYoutubeDimensions && (e = s.maxYoutubeDimensions.width, t = s.maxYoutubeDimensions.height), r.b(e, t);
                }, this.handleCustomLoad = function() {
                    var e = i[t], n = e.offsetWidth, s = e.offsetHeight;
                    n && s ? r.b(n, s) : setTimeout(o.handleCustomLoad);
                };
            }
            function F(e, t, n) {
                var o = e.elements.sources, i = e.props.customClasses, s = i[t] ? i[t] : "";
                o[t].className = n + " " + s;
            }
            function I(e, t) {
                var n = e.elements.sources, o = e.props.customAttributes;
                for(var i in o[t])n[t].setAttribute(i, o[t][i]);
            }
            function z(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, s = o.sourceAnimationWrappers, r = e.props.sources;
                i[t] = document.createElement("img"), F(e, t, y), i[t].src = r[t], i[t].onload = n[t].handleImageLoad, I(e, t), s[t].appendChild(i[t]);
            }
            function T(e, t) {
                var n = e.ap, o = e.collections.sourceLoadHandlers, i = e.elements, s = i.sources, r = i.sourceAnimationWrappers, a = e.props, c = a.sources, l = a.videosPosters, u = document.createElement("video"), d = document.createElement("source");
                s[t] = u, F(e, t, "".concat(y, " fslightboxv")), u.src = c[t], u.onloadedmetadata = function(e) {
                    return o[t].handleVideoLoad(e);
                }, u.controls = !0, u.autoplay = n.i(t), I(e, t), l[t] && (s[t].poster = l[t]), d.src = c[t], u.appendChild(d), setTimeout(o[t].handleNotMetaDatedVideoLoad, 3e3), r[t].appendChild(s[t]);
            }
            function N(e, t) {
                var n = e.ap, o = e.collections.sourceLoadHandlers, s = e.elements, r = s.sources, a = s.sourceAnimationWrappers, c = e.props.sources[t], l = c.split("?")[1], u = document.createElement("iframe");
                r[t] = u, F(e, t, "".concat(y, " ").concat(i, "youtube-iframe")), u.src = "https://www.youtube.com/embed/".concat(c.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?").concat(l || "").concat(n.i(t) ? "&mute=1&autoplay=1" : "", "&enablejsapi=1"), u.allowFullscreen = !0, I(e, t), a[t].appendChild(u), o[t].handleYoutubeLoad(parseInt(u.width), parseInt(u.height));
            }
            function P(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, s = o.sourceAnimationWrappers, r = e.props.sources;
                i[t] = r[t], F(e, t, "".concat(i[t].className, " ").concat(y)), s[t].appendChild(i[t]), n[t].handleCustomLoad();
            }
            function k(e, t) {
                var n = e.elements, o = n.sources, s = n.sourceAnimationWrappers;
                e.props.sources;
                o[t] = document.createElement("div"), o[t].className = "".concat(i, "invalid-file-wrapper ").concat(c), o[t].innerHTML = "Invalid source", s[t].appendChild(o[t]), new A(e, t).a();
            }
            function R(e) {
                var t = e.collections, n = t.sourceLoadHandlers, o = t.sourcesRenderFunctions, i = e.core.sourceDisplayFacade, s = e.resolve;
                this.runActionsForSourceTypeAndIndex = function(t, r) {
                    var a;
                    switch("invalid" !== t && (n[r] = s(E, [
                        r
                    ])), t){
                        case "image":
                            a = z;
                            break;
                        case "video":
                            a = T;
                            break;
                        case "youtube":
                            a = N;
                            break;
                        case "custom":
                            a = P;
                            break;
                        default:
                            a = k;
                    }
                    o[r] = function() {
                        return a(e, r);
                    }, i.displaySourcesWhichShouldBeDisplayed();
                };
            }
            function M(e, t, n) {
                var o = e.props, i = o.types, s = o.type, r = o.sources;
                this.getTypeSetByClientForIndex = function(e) {
                    var t;
                    return i && i[e] ? t = i[e] : s && (t = s), t;
                }, this.retrieveTypeWithXhrForIndex = function(e) {
                    !function(e, t) {
                        var n = document.createElement("a");
                        n.href = e;
                        var o = n.hostname;
                        if ("www.youtube.com" === o || "youtu.be" === o) return t("youtube");
                        var i = new XMLHttpRequest;
                        i.onreadystatechange = function() {
                            if (4 !== i.readyState) {
                                if (2 === i.readyState) {
                                    var e, n = i.getResponseHeader("content-type");
                                    switch(n.slice(0, n.indexOf("/"))){
                                        case "image":
                                            e = "image";
                                            break;
                                        case "video":
                                            e = "video";
                                            break;
                                        default:
                                            e = "invalid";
                                    }
                                    i.onreadystatechange = null, i.abort(), t(e);
                                }
                            } else t("invalid");
                        }, i.open("GET", e), i.send();
                    }(r[e], function(o) {
                        t.handleReceivedSourceTypeForUrl(o, r[e]), n.runActionsForSourceTypeAndIndex(o, e);
                    });
                };
            }
            function H(e, t) {
                var n = e.core.stageManager, o = e.elements, i = o.smw, s = o.sourceWrappersContainer, r = e.props, l = 0, f = document.createElement("div");
                function p(e) {
                    f.style.transform = "translateX(".concat(e + l, "px)"), l = 0;
                }
                function h() {
                    return (1 + r.slideDistance) * innerWidth;
                }
                f.className = "".concat(d, " ").concat(a, " ").concat(c), f.s = function() {
                    f.style.display = "flex";
                }, f.h = function() {
                    f.style.display = "none";
                }, f.a = function() {
                    f.classList.add(u);
                }, f.d = function() {
                    f.classList.remove(u);
                }, f.n = function() {
                    f.style.removeProperty("transform");
                }, f.v = function(e) {
                    return l = e, f;
                }, f.ne = function() {
                    p(-h());
                }, f.z = function() {
                    p(0);
                }, f.p = function() {
                    p(h());
                }, n.i(t) || f.h(), i[t] = f, s.appendChild(f), function(e, t) {
                    var n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, s = document.createElement("div"), r = document.createElement("div");
                    r.className = "fslightboxl";
                    for(var a = 0; a < 3; a++){
                        var c = document.createElement("div");
                        r.appendChild(c);
                    }
                    s.appendChild(r), o[t].appendChild(s), i[t] = s;
                }(e, t);
            }
            function W(e, t, n) {
                var o = document.createElementNS("http://www.w3.org/2000/svg", "svg"), s = "".concat(i, "svg");
                o.setAttributeNS(null, "class", "".concat(s)), o.setAttributeNS(null, "viewBox", t);
                var r = document.createElementNS("http://www.w3.org/2000/svg", "path");
                return r.setAttributeNS(null, "class", "".concat(s, "p")), r.setAttributeNS(null, "d", n), o.appendChild(r), e.appendChild(o), o;
            }
            function D(e, t) {
                var n = document.createElement("button");
                return n.className = "fslightboxb ".concat(i, "toolbar-button ").concat(c), n.title = t, e.appendChild(n), n;
            }
            function O(e, t) {
                var n = document.createElement("div");
                n.className = "".concat(i, "toolbar"), t.appendChild(n), function(e, t) {
                    if (!e.hfs) {
                        var n = "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z", o = D(t);
                        o.title = "Enter fullscreen";
                        var s = W(o, "0 0 18 18", n);
                        e.fso = function() {
                            e.ifs = 1, o.title = "Exit fullscreen", s.classList.add("".concat(i, "fsx")), s.setAttributeNS(null, "viewBox", "0 0 950 1024"), s.firstChild.setAttributeNS(null, "d", "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");
                        }, e.fsx = function() {
                            e.ifs = 0, o.title = "Enter fullscreen", s.classList.remove("".concat(i, "fsx")), s.setAttributeNS(null, "viewBox", "0 0 18 18"), s.firstChild.setAttributeNS(null, "d", n);
                        }, o.onclick = e.fs.t;
                    }
                }(e, n), function(e, t) {
                    var n = D(t, "Close");
                    n.onclick = e.core.lightboxCloser.closeLightbox, W(n, "0 0 24 24", "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");
                }(e, n);
            }
            function j(e) {
                var t = e.props.sources, n = e.elements.container, o = document.createElement("div");
                o.className = "".concat(i, "nav"), n.appendChild(o), O(e, o), t.length > 1 && function(e, t) {
                    var n = e.props.sources, o = (e.stageIndexes, document.createElement("div")), i = document.createElement("span"), s = document.createElement("span"), r = document.createElement("span");
                    o.className = "fslightboxsn", e.sn = function(e) {
                        return i.innerHTML = e;
                    }, s.className = "fslightboxsl", r.innerHTML = n.length, o.appendChild(i), o.appendChild(s), o.appendChild(r), t.appendChild(o);
                }(e, o);
            }
            function X(e, t, n, o) {
                var i = e.elements.container, s = n.charAt(0).toUpperCase() + n.slice(1), r = document.createElement("div");
                r.className = "".concat(p, " ").concat(p, "-").concat(n), r.title = "".concat(s, " slide"), r.onclick = t, function(e, t) {
                    var n = document.createElement("button");
                    n.className = "fslightboxb ".concat(f, " ").concat(c), W(n, "0 0 20 20", t), e.appendChild(n);
                }(r, o), i.appendChild(r);
            }
            function q(e) {
                var t = e.core, n = t.lightboxCloser, o = t.slideChangeFacade, i = e.fs;
                this.listener = function(e) {
                    switch(e.key){
                        case "Escape":
                            n.closeLightbox();
                            break;
                        case "ArrowLeft":
                            o.changeToPrevious();
                            break;
                        case "ArrowRight":
                            o.changeToNext();
                            break;
                        case "F11":
                            e.preventDefault(), i.t();
                    }
                };
            }
            function B(e) {
                var t = e.elements, n = e.sourcePointerProps, o = e.stageIndexes;
                function i(e, o) {
                    t.smw[e].v(n.swipedX)[o]();
                }
                this.runActionsForEvent = function(e) {
                    var s, a, c;
                    t.container.contains(t.slideSwipingHoverer) || t.container.appendChild(t.slideSwipingHoverer), s = t.container, a = r, (c = s.classList).contains(a) || c.add(a), n.swipedX = e.screenX - n.downScreenX;
                    var l = o.previous, u = o.next;
                    i(o.current, "z"), void 0 !== l && n.swipedX > 0 ? i(l, "ne") : void 0 !== u && n.swipedX < 0 && i(u, "p");
                };
            }
            function V(e) {
                var t = e.dss, n = e.props.sources, o = e.resolve, i = e.sourcePointerProps, s = o(B);
                1 === n.length || t ? this.listener = function() {
                    i.swipedX = 1;
                } : this.listener = function(e) {
                    i.isPointering && s.runActionsForEvent(e);
                };
            }
            function U(e) {
                var t = e.core.slideIndexChanger, n = e.elements.smw, o = e.stageIndexes, i = e.sws;
                function s(e) {
                    var t = n[o.current];
                    t.a(), t[e]();
                }
                function r(e, t) {
                    void 0 !== e && (n[e].s(), n[e][t]());
                }
                this.runPositiveSwipedXActions = function() {
                    var e = o.previous;
                    if (void 0 === e) s("z");
                    else {
                        s("p");
                        var n = o.next;
                        t.changeTo(e);
                        var a = o.previous;
                        i.d(a), i.b(n), s("z"), r(a, "ne");
                    }
                }, this.runNegativeSwipedXActions = function() {
                    var e = o.next;
                    if (void 0 === e) s("z");
                    else {
                        s("ne");
                        var n = o.previous;
                        t.changeTo(e);
                        var a = o.next;
                        i.d(a), i.b(n), s("z"), r(a, "p");
                    }
                };
            }
            function _(e, t) {
                e.contains(t) && e.removeChild(t);
            }
            function Y(e) {
                var t = e.core.lightboxCloser, n = e.dss, o = e.elements, i = e.props, s = e.resolve, a = e.sourcePointerProps, c = s(U);
                this.runNoSwipeActions = function() {
                    _(o.container, o.slideSwipingHoverer), a.isSourceDownEventTarget || i.disableBackgroundClose || t.closeLightbox(), a.isPointering = !1;
                }, this.runActions = function() {
                    n || (a.swipedX > 0 ? c.runPositiveSwipedXActions() : c.runNegativeSwipedXActions()), _(o.container, o.slideSwipingHoverer), o.container.classList.remove(r), a.isPointering = !1;
                };
            }
            function J(e) {
                var t = e.resolve, n = e.sourcePointerProps, o = t(Y);
                this.listener = function() {
                    n.isPointering && (n.swipedX ? o.runActions() : o.runNoSwipeActions());
                };
            }
            function G(e) {
                var t = this, n = e.core, o = n.globalEventsController, i = n.scrollbarRecompensor, s = (e.data, e.e), r = e.elements, a = e.fs, c = e.props, u = e.sourcePointerProps;
                this.runActions = function() {
                    t.i = 1, r.container.classList.add(b), o.removeListeners(), c.exitFullscreenOnClose && e.ifs && a.x(), setTimeout(function() {
                        t.i = 0, u.isPointering = !1, r.container.classList.remove(b), document.documentElement.classList.remove(l), i.removeRecompense(), document.body.removeChild(r.container), s("onClose");
                    }, 270);
                };
            }
            function $(e, t) {
                var n = e.classList;
                n.contains(t) && n.remove(t);
            }
            function K(e) {
                var t, n, o, i, s, r, a, c, l;
                !function(e) {
                    var t = e.ap, n = e.elements.sources, o = e.props, i = o.autoplay, s = o.autoplays;
                    function r(e, o) {
                        if ("play" != o || t.i(e)) {
                            var i = n[e];
                            if (i) {
                                var s = i.tagName;
                                if ("VIDEO" == s) i[o]();
                                else if ("IFRAME" == s) {
                                    var r = i.contentWindow;
                                    r && r.postMessage('{"event":"command","func":"'.concat(o, 'Video","args":""}'), "*");
                                }
                            }
                        }
                    }
                    t.i = function(e) {
                        return s[e] || i && 0 != s[e];
                    }, t.p = function(e) {
                        r(e, "play");
                    }, t.c = function(e, t) {
                        r(e, "pause"), r(t, "play");
                    };
                }(e), function(e) {
                    e.data;
                    var t = e.fs, n = [
                        "fullscreenchange",
                        "webkitfullscreenchange",
                        "mozfullscreenchange",
                        "MSFullscreenChange"
                    ], o = document.documentElement, i = o.requestFullscreen;
                    function s(e) {
                        for(var t = 0; t < n.length; t++)document[e](n[t], r);
                    }
                    function r() {
                        document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement ? e.fso() : e.fsx();
                    }
                    t.i = function() {
                        if (i || (i = o.mozRequestFullScreen), i || (i = o.webkitRequestFullscreen), i || (i = o.msRequestFullscreen), !i) return e.hfs = 1, t.o = function() {}, t.x = function() {}, t.t = function() {}, t.l = function() {}, void (t.q = function() {});
                        t.o = function() {
                            e.fso();
                            var t = document.documentElement;
                            t.requestFullscreen ? t.requestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : t.msRequestFullscreen && t.msRequestFullscreen();
                        }, t.x = function() {
                            e.fsx(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                        }, t.t = function() {
                            e.ifs ? t.x() : t.o();
                        }, t.l = function() {
                            s("addEventListener");
                        }, t.q = function() {
                            s("removeEventListener");
                        };
                    };
                }(e), n = (t = e).core, o = n.globalEventsController, i = n.windowResizeActioner, s = t.fs, r = t.resolve, a = r(q), c = r(V), l = r(J), o.attachListeners = function() {
                    document.addEventListener("pointermove", c.listener), document.addEventListener("pointerup", l.listener), addEventListener("resize", i.runActions), document.addEventListener("keydown", a.listener), s.l();
                }, o.removeListeners = function() {
                    document.removeEventListener("pointermove", c.listener), document.removeEventListener("pointerup", l.listener), removeEventListener("resize", i.runActions), document.removeEventListener("keydown", a.listener), s.q();
                }, function(e) {
                    var t = e.core.lightboxCloser, n = (0, e.resolve)(G);
                    t.closeLightbox = function() {
                        n.isLightboxFadingOut || n.runActions();
                    };
                }(e), function(e) {
                    var t = e.data, n = e.core.scrollbarRecompensor;
                    function o() {
                        document.body.offsetHeight > innerHeight && (document.body.style.marginRight = t.scrollbarWidth + "px");
                    }
                    n.addRecompense = function() {
                        "complete" === document.readyState ? o() : addEventListener("load", function() {
                            o(), n.addRecompense = o;
                        });
                    }, n.removeRecompense = function() {
                        document.body.style.removeProperty("margin-right");
                    };
                }(e), function(e) {
                    var t = e.core, n = t.slideChangeFacade, o = t.slideIndexChanger, i = t.stageManager;
                    e.props.sources.length > 1 ? (n.changeToPrevious = function() {
                        o.jumpTo(i.getPreviousSlideIndex());
                    }, n.changeToNext = function() {
                        o.jumpTo(i.getNextSlideIndex());
                    }) : (n.changeToPrevious = function() {}, n.changeToNext = function() {});
                }(e), function(e) {
                    var t = e.ap, n = (e.componentsServices, e.core), o = n.slideIndexChanger, i = n.sourceDisplayFacade, s = n.stageManager, r = e.elements, a = r.smw, c = r.sourceAnimationWrappers, l = e.isl, u = e.stageIndexes, d = e.sws;
                    o.changeTo = function(n) {
                        t.c(u.current, n), u.current = n, s.updateStageIndexes(), e.sn(n + 1), i.displaySourcesWhichShouldBeDisplayed();
                    }, o.jumpTo = function(e) {
                        var t = u.previous, n = u.current, i = u.next, r = l[n], f = l[e];
                        o.changeTo(e);
                        for(var p = 0; p < a.length; p++)a[p].d();
                        d.d(n), d.c(), requestAnimationFrame(function() {
                            requestAnimationFrame(function() {
                                var e = u.previous, o = u.next;
                                function p() {
                                    s.i(n) ? n === u.previous ? a[n].ne() : n === u.next && a[n].p() : (a[n].h(), a[n].n());
                                }
                                r && c[n].classList.add(g), f && c[u.current].classList.add(h), d.a(), void 0 !== e && e !== n && a[e].ne(), a[u.current].n(), void 0 !== o && o !== n && a[o].p(), d.b(t), d.b(i), l[n] ? setTimeout(p, 260) : p();
                            });
                        });
                    };
                }(e), function(e) {
                    var t = e.core.sourcesPointerDown, n = e.elements, o = n.smw, i = n.sources, s = e.sourcePointerProps, r = e.stageIndexes;
                    t.listener = function(e) {
                        "VIDEO" !== e.target.tagName && e.preventDefault(), s.isPointering = !0, s.downScreenX = e.screenX, s.swipedX = 0;
                        var t = i[r.current];
                        t && t.contains(e.target) ? s.isSourceDownEventTarget = !0 : s.isSourceDownEventTarget = !1;
                        for(var n = 0; n < o.length; n++)o[n].d();
                    };
                }(e), function(e) {
                    var t = e.collections.sourcesRenderFunctions, n = e.core.sourceDisplayFacade, o = e.loc, i = e.stageIndexes;
                    function s(e) {
                        t[e] && (t[e](), delete t[e]);
                    }
                    n.displaySourcesWhichShouldBeDisplayed = function() {
                        if (o) s(i.current);
                        else for(var e in i)s(i[e]);
                    };
                }(e), function(e) {
                    var t = e.core.stageManager, n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, s = e.isl, r = e.stageIndexes, a = e.sws;
                    a.a = function() {
                        for(var e in r)o[r[e]].s();
                    }, a.b = function(e) {
                        void 0 === e || t.i(e) || (o[e].h(), o[e].n());
                    }, a.c = function() {
                        for(var e in r)a.d(r[e]);
                    }, a.d = function(e) {
                        if (s[e]) {
                            var t = i[e];
                            $(t, m), $(t, h), $(t, g);
                        }
                    };
                }(e), function(e) {
                    var t = e.collections.sourceSizers, n = e.core.windowResizeActioner, o = (e.data, e.elements.smw), i = e.props.sourceMargin, s = e.stageIndexes, r = 1 - 2 * i;
                    n.runActions = function() {
                        innerWidth > 992 ? e.mw = r * innerWidth : e.mw = innerWidth, e.mh = r * innerHeight;
                        for(var n = 0; n < o.length; n++)o[n].d(), t[n] && t[n].adjustSize();
                        var i = s.previous, a = s.next;
                        void 0 !== i && o[i].ne(), void 0 !== a && o[a].p();
                    };
                }(e);
            }
            function Q(e) {
                var t = e.ap, n = (e.componentsServices, e.core), o = n.globalEventsController, s = n.scrollbarRecompensor, r = n.sourceDisplayFacade, c = n.stageManager, u = n.windowResizeActioner, f = e.data, p = e.e, h = e.elements, g = (e.props, e.stageIndexes), b = e.sws, v = 0;
                function x() {
                    var t, n, o = e.props, s = o.autoplay, r = o.autoplays;
                    v = !0, function(e) {
                        var t = e.props, n = t.autoplays;
                        e.c = t.sources.length;
                        for(var o = 0; o < e.c; o++)"false" === n[o] && (n[o] = 0), "" === n[o] && (n[o] = 1);
                        e.dss = t.disableSlideSwiping, e.loc = t.loadOnlyCurrentSource;
                    }(e), f.scrollbarWidth = function() {
                        var e = document.createElement("div"), t = e.style, n = document.createElement("div");
                        t.visibility = "hidden", t.width = "100px", t.msOverflowStyle = "scrollbar", t.overflow = "scroll", n.style.width = "100%", document.body.appendChild(e);
                        var o = e.offsetWidth;
                        e.appendChild(n);
                        var i = n.offsetWidth;
                        return document.body.removeChild(e), o - i;
                    }(), (s || r.length > 0) && (e.loc = 1), K(e), e.fs.i(), h.container = document.createElement("div"), h.container.className = "".concat(i, "container ").concat(a, " ").concat(m), h.container.setAttribute("tabindex", "0"), function(e) {
                        var t = e.elements;
                        t.slideSwipingHoverer = document.createElement("div"), t.slideSwipingHoverer.className = "".concat(i, "slide-swiping-hoverer ").concat(a, " ").concat(d);
                    }(e), j(e), function(e) {
                        var t = e.core.sourcesPointerDown, n = e.elements, o = e.props.sources, i = document.createElement("div");
                        i.className = "".concat(d, " ").concat(a), n.container.appendChild(i), i.addEventListener("pointerdown", t.listener), n.sourceWrappersContainer = i;
                        for(var s = 0; s < o.length; s++)H(e, s);
                    }(e), e.props.sources.length > 1 && (n = (t = e).core.slideChangeFacade, X(t, n.changeToPrevious, "previous", "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"), X(t, n.changeToNext, "next", "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z")), function(e) {
                        for(var t = e.props.sources, n = e.resolve, o = n(L), i = n(R), s = n(M, [
                            o,
                            i
                        ]), r = 0; r < t.length; r++)if ("string" == typeof t[r]) {
                            var a = s.getTypeSetByClientForIndex(r);
                            if (a) i.runActionsForSourceTypeAndIndex(a, r);
                            else {
                                var c = o.getSourceTypeFromLocalStorageByUrl(t[r]);
                                c ? i.runActionsForSourceTypeAndIndex(c, r) : s.retrieveTypeWithXhrForIndex(r);
                            }
                        } else i.runActionsForSourceTypeAndIndex("custom", r);
                    }(e), p("onInit");
                }
                e.open = function() {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = g.previous, a = g.current, d = g.next;
                    g.current = n, v || S(e), c.updateStageIndexes(), v ? (b.c(), b.a(), b.b(i), b.b(a), b.b(d), p("onShow")) : x(), r.displaySourcesWhichShouldBeDisplayed(), e.sn(n + 1), document.body.appendChild(h.container), h.container.focus(), document.documentElement.classList.add(l), s.addRecompense(), o.attachListeners(), u.runActions(), h.smw[n].n(), t.p(n), p("onOpen");
                };
            }
            function Z(e, t, n) {
                return (Z = ee() ? Reflect.construct.bind() : function(e, t, n) {
                    var o = [
                        null
                    ];
                    o.push.apply(o, t);
                    var i = new (Function.bind.apply(e, o));
                    return n && te(i, n.prototype), i;
                }).apply(null, arguments);
            }
            function ee() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function te(e, t) {
                return (te = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function ne(e) {
                return function(e) {
                    if (Array.isArray(e)) return oe(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (!e) return;
                    if ("string" == typeof e) return oe(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === n && e.constructor && (n = e.constructor.name);
                    if ("Map" === n || "Set" === n) return Array.from(e);
                    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return oe(e, t);
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function oe(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, o = new Array(t); n < t; n++)o[n] = e[n];
                return o;
            }
            function ie() {
                for(var e = document.getElementsByTagName("a"), t = function(t) {
                    if (!e[t].hasAttribute("data-fslightbox")) return "continue";
                    var n = e[t].hasAttribute("data-href") ? e[t].getAttribute("data-href") : e[t].getAttribute("href");
                    if (!n) return console.warn('The "data-fslightbox" attribute was set without the "href" attribute.'), "continue";
                    var o = e[t].getAttribute("data-fslightbox");
                    fsLightboxInstances[o] || (fsLightboxInstances[o] = new FsLightbox);
                    var i = null;
                    "#" === n.charAt(0) ? (i = document.getElementById(n.substring(1)).cloneNode(!0)).removeAttribute("id") : i = n, fsLightboxInstances[o].props.sources.push(i), fsLightboxInstances[o].elements.a.push(e[t]);
                    var s = fsLightboxInstances[o].props.sources.length - 1;
                    e[t].onclick = function(e) {
                        e.preventDefault(), fsLightboxInstances[o].open(s);
                    }, d("types", "data-type"), d("videosPosters", "data-video-poster"), d("customClasses", "data-class"), d("customClasses", "data-custom-class"), d("autoplays", "data-autoplay");
                    for(var r = [
                        "href",
                        "data-fslightbox",
                        "data-href",
                        "data-type",
                        "data-video-poster",
                        "data-class",
                        "data-custom-class",
                        "data-autoplay"
                    ], a = e[t].attributes, c = fsLightboxInstances[o].props.customAttributes, l = 0; l < a.length; l++)if (-1 === r.indexOf(a[l].name) && "data-" === a[l].name.substr(0, 5)) {
                        c[s] || (c[s] = {});
                        var u = a[l].name.substr(5);
                        c[s][u] = a[l].value;
                    }
                    function d(n, i) {
                        e[t].hasAttribute(i) && (fsLightboxInstances[o].props[n][s] = e[t].getAttribute(i));
                    }
                }, n = 0; n < e.length; n++)t(n);
                var o = Object.keys(fsLightboxInstances);
                window.fsLightbox = fsLightboxInstances[o[o.length - 1]];
            }
            window.FsLightbox = function() {
                var e = this;
                this.props = {
                    sources: [],
                    customAttributes: [],
                    customClasses: [],
                    autoplays: [],
                    types: [],
                    videosPosters: [],
                    exitFullscreenOnClose: 1,
                    sourceMargin: .05,
                    slideDistance: .3
                }, this.data = {
                    isFullscreenOpen: !1,
                    scrollbarWidth: 0
                }, this.isl = [], this.sourcePointerProps = {
                    downScreenX: null,
                    isPointering: !1,
                    isSourceDownEventTarget: !1,
                    swipedX: 0
                }, this.stageIndexes = {}, this.elements = {
                    a: [],
                    container: null,
                    slideSwipingHoverer: null,
                    smw: [],
                    sourceWrappersContainer: null,
                    sources: [],
                    sourceAnimationWrappers: []
                }, this.sn = function() {}, this.resolve = function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    return n.unshift(e), Z(t, ne(n));
                }, this.collections = {
                    sourceLoadHandlers: [],
                    sourcesRenderFunctions: [],
                    sourceSizers: []
                }, this.core = {
                    globalEventsController: {},
                    lightboxCloser: {},
                    lightboxUpdater: {},
                    scrollbarRecompensor: {},
                    slideChangeFacade: {},
                    slideIndexChanger: {},
                    sourcesPointerDown: {},
                    sourceDisplayFacade: {},
                    stageManager: {},
                    windowResizeActioner: {}
                }, this.ap = {}, this.fs = {}, this.sws = {}, this.e = function(t) {
                    e.props[t] && e.props[t](e);
                }, Q(this), this.close = function() {
                    return e.core.lightboxCloser.closeLightbox();
                };
            }, window.fsLightboxInstances = {}, ie(), window.refreshFsLightbox = function() {
                for(var e in fsLightboxInstances){
                    var t = fsLightboxInstances[e].props;
                    fsLightboxInstances[e] = new FsLightbox, fsLightboxInstances[e].props = t, fsLightboxInstances[e].props.sources = [], fsLightboxInstances[e].elements.a = [];
                }
                ie();
            };
        }
    ]);
});


function $56e2c3e09bdfd969$var$isMobile() {
    return window.innerWidth < 640;
}
function $56e2c3e09bdfd969$var$showFormSuccessBox() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("form") === "success") {
        (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))("#form-success").removeClass("hidden");
        $56e2c3e09bdfd969$var$pushTrackingEvent("generate_lead", {
            lead_type: "contact_form",
            form_name: "form-contato"
        });
        params.delete("form");
        const query = params.toString();
        const url = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
        window.history.replaceState(null, document.title, url);
    }
}
const $56e2c3e09bdfd969$var$TRACKING_PARAM_NAMES = {
    trackMethod: "contact_method",
    trackLocation: "cta_location",
    trackLabel: "cta_label",
    trackLeadType: "lead_type",
    trackProductId: "product_id",
    trackProductName: "product_name",
    trackFileName: "file_name",
    trackFileType: "file_type",
    trackFileExtension: "file_extension"
};
let $56e2c3e09bdfd969$var$semanticTrackingInitialized = false;
function $56e2c3e09bdfd969$var$camelToSnake(input) {
    return input.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`);
}
function $56e2c3e09bdfd969$var$getTrackingParamName(datasetKey) {
    if ($56e2c3e09bdfd969$var$TRACKING_PARAM_NAMES[datasetKey]) return $56e2c3e09bdfd969$var$TRACKING_PARAM_NAMES[datasetKey];
    return $56e2c3e09bdfd969$var$camelToSnake(datasetKey.replace(/^track/, "")).replace(/^_/, "");
}
function $56e2c3e09bdfd969$var$getTrackingParams(target) {
    const params = {};
    Object.entries(target.dataset).forEach(([key, value])=>{
        if (!key.startsWith("track") || key === "trackEvent" || key === "trackSecondaryEvent" || !value) return;
        params[$56e2c3e09bdfd969$var$getTrackingParamName(key)] = value;
    });
    return params;
}
function $56e2c3e09bdfd969$var$isContactHref(href) {
    if (href.startsWith("tel:") || href.startsWith("mailto:")) return true;
    try {
        const url = new URL(href, window.location.href);
        return [
            "wa.me",
            "api.whatsapp.com",
            "web.whatsapp.com"
        ].includes(url.hostname);
    } catch  {
        return false;
    }
}
function $56e2c3e09bdfd969$var$pushTrackingEvent(eventName, params = {}, link) {
    const payload = {
        event: eventName,
        page_path: window.location.pathname,
        ...params
    };
    if (link && !$56e2c3e09bdfd969$var$isContactHref(link.href)) payload.link_url = link.href;
    const currentWindow = window;
    currentWindow.dataLayer = currentWindow.dataLayer || [];
    currentWindow.dataLayer.push(payload);
}
function $56e2c3e09bdfd969$var$initSemanticTracking() {
    if ($56e2c3e09bdfd969$var$semanticTrackingInitialized) return;
    $56e2c3e09bdfd969$var$semanticTrackingInitialized = true;
    document.addEventListener("click", (event)=>{
        if (!(event.target instanceof Element)) return;
        const target = event.target.closest("[data-track-event]");
        if (!target) return;
        const eventName = target.dataset.trackEvent;
        if (!eventName) return;
        const params = $56e2c3e09bdfd969$var$getTrackingParams(target);
        const link = target instanceof HTMLAnchorElement ? target : target.closest("a");
        $56e2c3e09bdfd969$var$pushTrackingEvent(eventName, params, link instanceof HTMLAnchorElement ? link : undefined);
        if (target.dataset.trackSecondaryEvent) $56e2c3e09bdfd969$var$pushTrackingEvent(target.dataset.trackSecondaryEvent, params, link instanceof HTMLAnchorElement ? link : undefined);
    });
}
$56e2c3e09bdfd969$var$initSemanticTracking();
// Cookie notice (docs/spec/2026-11-03-cookie-notice-ga-pull.md S2): shown until the visitor presses OK.
// Every storage access is in try/catch: localStorage throws when the browser blocks site data.
const $56e2c3e09bdfd969$var$COOKIE_NOTICE_KEY = "cookie_notice_ok";
function $56e2c3e09bdfd969$var$cookieNoticeDismissed() {
    try {
        return window.localStorage.getItem($56e2c3e09bdfd969$var$COOKIE_NOTICE_KEY) === "1";
    } catch  {
        return false;
    }
}
function $56e2c3e09bdfd969$var$rememberCookieNoticeDismissed() {
    try {
        window.localStorage.setItem($56e2c3e09bdfd969$var$COOKIE_NOTICE_KEY, "1");
    } catch  {
    // Storage blocked: OK still hides the notice, for this page only.
    }
}
function $56e2c3e09bdfd969$var$initCookieNotice() {
    const notice = document.getElementById("cookie-notice");
    const ok = document.getElementById("cookie-notice-ok");
    if (!notice || !ok || $56e2c3e09bdfd969$var$cookieNoticeDismissed()) return;
    // Room below the footer, so the fixed notice can't cover its last links (WhatsApp, language).
    const reserveSpace = ()=>{
        document.body.style.paddingBottom = notice.hidden ? "" : `${notice.offsetHeight + 16}px`;
    };
    notice.hidden = false;
    reserveSpace();
    window.addEventListener("resize", reserveSpace);
    ok.addEventListener("click", ()=>{
        notice.hidden = true;
        reserveSpace();
        window.removeEventListener("resize", reserveSpace);
        $56e2c3e09bdfd969$var$rememberCookieNoticeDismissed();
    });
}
// main.js is deferred, so the DOM is parsed here; no need to wait for window.onload (images).
$56e2c3e09bdfd969$var$initCookieNotice();
function $56e2c3e09bdfd969$var$initOffside() {
    const offcanvasMenuId = "#sidemenu";
    const slidingElementsSelectorId = "#main";
    (0, (/*@__PURE__*/$parcel$interopDefault($35330021ee0eb054$exports)))(offcanvasMenuId, {
        slidingElementsSelector: slidingElementsSelectorId,
        buttonsSelector: "#close-offcanvas, #open-offcanvas",
        slidingSide: "left",
        // fixes initial "flashing" of the menu on load
        beforeOpen: ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))(offcanvasMenuId).removeClass('hidden');
        }
    });
}
function $56e2c3e09bdfd969$var$initCarousel() {
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($59c4f5e8925f3128$exports)))(".splide").first();
    let lastState = null;
    let lastSplide = null;
    if (target[0] ?? false) {
        const initSplide = ()=>{
            if (lastState == $56e2c3e09bdfd969$var$isMobile()) {
                window.requestAnimationFrame(initSplide);
                return;
            }
            lastState = $56e2c3e09bdfd969$var$isMobile();
            let perPage = $56e2c3e09bdfd969$var$isMobile() ? 1 : 3;
            const splideOptions = {
                arrows: true,
                perMove: 1,
                perPage: perPage,
                type: 'loop',
                classes: {
                    pagination: 'splide__pagination',
                    page: 'splide__pagination__page !bg-neutral-800'
                }
            };
            if (lastSplide !== null) lastSplide.destroy();
            lastSplide = new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(target[0], splideOptions);
            lastSplide.mount();
            window.requestAnimationFrame(initSplide);
        };
        initSplide();
    }
}
window.onload = function(a) {
    $56e2c3e09bdfd969$var$initSemanticTracking();
    $56e2c3e09bdfd969$var$initCarousel();
    (0, $a6897314d3ddc1a0$export$84570464b5512114)();
    $56e2c3e09bdfd969$var$initOffside();
    $56e2c3e09bdfd969$var$showFormSuccessBox();
    new (0, (/*@__PURE__*/$parcel$interopDefault($5002af504f38f331$exports)))({
        container: ".magic-grid",
        static: true,
        animate: true
    }).listen();
};

})();
//# sourceMappingURL=main.js.map
